
import BookingSdnBanner from "@/app/ui/components/booking-sdn-banner/index.vue";
/* eslint-disable @typescript-eslint/camelcase */
import { Vue, Options, prop } from "vue-class-component";
import {
  CreateBookingV4,
  ErrorBookingV4,
  BookingTabV4,
  ReceiptFormatV4,
  FormCompletionSectionKeyV4,
  FormCompletionSectionStateV4,
  FormCompletionSectionBookingV4,
  FormCompletionFieldRowV4,
  FormCompletionPanelItemV4,
  PaymentMethodBookingV4,
  PaymentMethodOptionV4,
  PaymentMethodV4,
  PageMetaBookingV4,
  SenderBookingV4,
  CommodityBookingV4,
  CommodityCategoryV4,
  PieceBookingV4,
  CommodityCiplBookingV4,
  HwsThresholdConfig,
  ProductBookingV4,
  ReferenceChipV4,
  ProtectionPackingBookingV4,
  ChargeableWeightBreakdownV4,
  SupportingDocBookingV4,
  DocInternationalBookingV4,
  ErrorPiecesBookingV4,
  ReceiverBookingV4,
  ProductCardItem,
  ShipmentIdTable
} from "@/domain/entities/BookingV4";
import { RequestInternationalDocumentDetail } from "@/domain/entities/InternationalDocument";
import {
  CountryData,
  DistrictData,
  ZipCodeEntities
} from "@/domain/entities/Location";
import { Commodity } from "@/domain/entities/Commodity";
import {
  ManualBookingV4Retail,
  GetEstimationPriceV4,
  RequestListCommodityV4,
  ProductConfigurationRuleRequestParamsV4,
  CIPLTypeV4
} from "@/data/payload/api/BookingV4Request";
import {
  EstimationPrice,
  // WoodpackingEligibility,
  InsuranceTypeDeliveryData,
  PayloadPosterProduct
} from "@/domain/entities/Booking";
import { ProductConfigurationRule } from "@/domain/entities/Product";
import {
  SttAdjustment,
  SttAdjustmentRule,
  SttReferenceAdjustment
} from "@/domain/entities/ShipmentBooking";
import {
  ConfigValidationForm,
  FraudStatus,
  PosterProduct
} from "@/domain/entities/CreateBookingV3";
import HeaderBookingV4 from "../header/index.vue";
import SenderSectionV4 from "../detail-sender/index.vue";
import ReceiverSectionV4 from "../detail-receiver/index.vue";
import ReferenceNumberV4 from "../reference-number/index.vue";
import { AccountTypeV4 } from "../reference-number/validationReferenceNumber";
import FormCompletionPanel from "../form-completion/index.vue";
import PaymentMethodSelectorV4 from "../footer-v2/payment/index.vue";
import GoodsPackageV4 from "../goods-package/index.vue";
import ProductCardListV4 from "../jenis-pengiriman/product-card-list.vue";
import ProtectionPackingSummary from "../protection-packing-summary/index.vue";
import BookingStickyFooterV4 from "../footer-v2/index.vue";
import TotalTarifSectionV4 from "../footer-v2/components/check-tariff.vue";
import SupportingDocSectionV4, {
  SupportingDocFieldKey
} from "../supporting-documents/index.vue";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { BookingController } from "@/app/ui/controllers/BookingController";
// import { InvoiceLimitController } from "@/app/ui/controllers/InvoiceLimitController";
import { BookingV4Controller } from "@/app/ui/controllers/BookingV4Controller";
import { ProductController } from "@/app/ui/controllers/ProductController";
import { CommodityController } from "@/app/ui/controllers/CommodityController";
import { InternationalDocumentController } from "@/app/ui/controllers/InternationalDocumentController";
import { Pagination } from "@/domain/entities/Pagination";
import {
  ApiRequestList,
  ErrorMessageEntities
} from "@/domain/entities/MainApp";
import {
  formatPriceRP,
  formatPriceRM,
  CLIENT_ERROR,
  formatByCountry
} from "@/app/infrastructures/misc/Utils";
import { FlagsPermissionBooking } from "@/feature-flags/flag-booking";
import {
  getCurrencyByCountryCode,
  isMalaysiaDistrict
} from "@/app/infrastructures/misc/common-library/MalaysiaDistrictFieldRules";
import { configPrice } from "@/app/infrastructures/misc/common-library/modules/Price";
import { getRoundedChargeableWeightByRules } from "@/app/infrastructures/misc/common-library/getRoundedChargeableWeightByRules";
import { isEligibleForMaxVolumeWeightDiscount } from "@/app/infrastructures/misc/common-library/IsEligibleForMaxVolumeWeightDiscount";
import {
  gapValidationCHWeightTokped,
  maxKg,
  prefixDisableDimension,
  prefixDisableDimensionC1,
  volumeWeightForProduct
} from "../../../booking-utils";
import { cloneDeep, debounce } from "lodash";
import { applyRecommendationOrder } from "../../../create-booking-v3/utils/applyRecommendationOrder";
import { FlagsPermissionBookingV3 } from "@/feature-flags/flag-booking-v3";
import { FlagsPermissionBookingV4 } from "@/feature-flags/flag-booking-v4";
import { resolveSelection } from "../../../create-booking-v3/utils/resolveDefaultProductName";
import {
  PiecesApiRequest,
  // WoodpackingEligibilityQuery
} from "@/data/payload/api/BookingRequest";
import { HeavyWeightSurchargeController } from "@/app/ui/controllers/HeavyWeightSurchargeController";
import { HeavyWeightSurchargeData } from "@/domain/entities/HeavyWeightSurcharge";
import { CodConfigurationController } from "@/app/ui/controllers/CodConfigurationController";
import {
  CodInternationalCountry,
  DetailCodConfigurationRetail
} from "@/domain/entities/CodConfiguration";
import { InsuranceController } from "@/app/ui/controllers/InsuranceController";
import { Insurance } from "@/domain/entities/Insurance";
import { isCustomerApps } from "@/app/ui/views/track-delivery/delivery-tab/modules/index";
import AdjustWeightSection from "./adjust-weight-section.vue";
import {
  AddShipmentBookingV2,
  ShipmentSttDetail,
  SttCiplRequest
} from "@/data/payload/api/ShipmentBookingRequest";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa/index";
import { FlagsFeatureShipmentC1 } from "@/feature-flags/flags-shipment-c1/index";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";
import { isInterpackInternationalProduct } from "@/app/infrastructures/misc/common-library/DetectLanguage";
import { DutyTaxConfigurationController } from "@/app/ui/controllers/DutyTaxConfigurationController";
import {
  DutyTaxResolveItemInput,
  DutyTaxResolveResult
} from "@/domain/entities/DutyTaxConfiguration";
import { parseByCountry } from "@/app/infrastructures/misc/common-library/FormatInputByCountry";
import { getToken } from "@/app/infrastructures/misc/Cookies";
import { isShipmentCa } from "@/app/ui/modules/receipt-v2/module";
import { getMinMaxGoodsPriceFromFlag } from "../../../create-booking-v3/components/detail-koli/product-price-insurance/validation";

type BookingTabV4Value = typeof BookingTabV4[keyof typeof BookingTabV4];
type ReceiptFormatV4Value = typeof ReceiptFormatV4[keyof typeof ReceiptFormatV4];
type FormCompletionSectionKeyV4Value = typeof FormCompletionSectionKeyV4[keyof typeof FormCompletionSectionKeyV4];

const parseCiplNumber = (value: string): number => {
  const normalized = String(value || "")
    .replace(/\./g, "")
    .replace(",", ".");
  return Number(normalized) || 0;
};

interface PaymentEligibilityV4 {
  cod: { disabled: boolean; hoverCopy: string };
  dfod: { disabled: boolean; hoverCopy: string };
  // posLimit: { disabled: boolean; remainingLimit: number };
}

const FORM_COMPLETION_SECTION_ANCHORS: Record<
  FormCompletionSectionKeyV4Value,
  string
> = {
  sender: "booking-v4-section-sender",
  receiver: "booking-v4-section-receiver",
  reference_number: "booking-v4-section-reference-number",
  goods_pieces: "booking-v4-section-goods-pieces",
  product_type: "booking-v4-section-product-type",
  supporting_documents: "booking-v4-section-supporting-documents",
  booking_v4_section_payment_method: "booking-v4-section-payment-method"
};

type SupportingDocCompletionFieldKey =
  | "email"
  | "idNumber"
  | "taxNumber"
  | "imageId"
  | "imageTax"
  | "imageBeforePacking"
  | "imageAfterPacking";

const SUPPORTING_DOC_COMPLETION_FIELD_ORDER: SupportingDocCompletionFieldKey[] = [
  "email",
  "idNumber",
  "taxNumber",
  "imageId",
  "imageTax",
  "imageBeforePacking",
  "imageAfterPacking"
];

const SUPPORTING_DOC_FIELD_LABEL_I18N: Record<
  typeof SUPPORTING_DOC_COMPLETION_FIELD_ORDER[number],
  string
> = {
  email: "bookingV4.formCompletion.email",
  idNumber: "bookingV4.formCompletion.idNumber",
  taxNumber: "bookingV4.formCompletion.taxNumber",
  imageId: "bookingV4.formCompletion.upload.idCard",
  imageTax: "bookingV4.formCompletion.upload.taxCard",
  imageBeforePacking: "bookingV4.formCompletion.upload.packing",
  imageAfterPacking: "bookingV4.formCompletion.upload.packing"
};

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean,
    required: true
  });
  data = prop<ShipmentIdTable[]>({
    default: () => [],
    type: Array
  });
  selectedIndex = prop<number>({
    default: 0,
    type: Number
  });
  isAddAddress = prop<boolean>({
    default: false,
    type: Boolean
  });
  isShipment = prop<boolean>({
    default: false,
    type: Boolean
  });
}

@Options({
  name: "ModalShipmentV4",
  components: {
    BookingSdnBanner,
    HeaderBookingV4,
    SenderSectionV4,
    ReceiverSectionV4,
    ReferenceNumberV4,
    FormCompletionPanel,
    PaymentMethodSelectorV4,
    GoodsPackageV4,
    ProductCardListV4,
    ProtectionPackingSummary,
    BookingStickyFooterV4,
    TotalTarifSectionV4,
    SupportingDocSectionV4,
    AdjustWeightSection
  },
  watch: {
    modelValue(value: boolean) {
      if (value) {
        this.initShipmentForm();
        return;
      }
      this.resetFormToDefault();
    },
    selectedIndex() {
      if (this.visible) {
        this.errors = new ErrorBookingV4();
        this.initShipmentForm();
      }
    },
    data() {
      if (this.visible && this.modelValue) {
        this.initShipmentForm();
      }
    },
    estimationPriceContextPayload: {
      handler() {
        this.getEstimationPriceDebounced();
      },
      deep: true
    },
    commodityCiplPrefillSignature() {
      this.commodityUserOverride = false;
      this.applyCommodityPrefillRules();
    },
    exchangeRatePairSignature() {
      this.syncActiveExchangeRate();
    },
    supportingDocContextSignature() {
      this.fetchSupportingDocFieldRules();
    },
    protectionDeriveSignature() {
      this.getInsuranceConfig();
      this.onSetInsurance();
      this.onSetWoodpacking();
    },
    productUpsellingContextSignature: {
      handler() {
        if (this.isTokopediaPrefix) return;

        this.fetchProductUpsellingDebounced();
      },
      deep: true
    },
    // woodpackingEligibilitySignature: {
    //   handler(): void {
    //     this.fetchWoodpackingEligibilityDebounced();
    //   },
    //   immediate: true
    // },
    dutyTaxResolveContextSignature() {
      this.getDutyTaxResolveDebounced();
    },
    "bookingFormV4.product.productType"(productNameValue: string) {
      if (productNameValue) {
        this.tempProductName = productNameValue;
      }
    },
    originCountry() {
      this.getInsuranceAvailability();
    },
    isApAsRouteCodDisabled(disabled: boolean) {
      if (
        disabled &&
        this.bookingFormV4.paymentMethod.method !== PaymentMethodV4.CASH
      ) {
        this.onPaymentMethodUpdate(
          new PaymentMethodBookingV4({ method: PaymentMethodV4.CASH })
        );
      }
    },
    removePieceTigger() {
      this.setErrorPiece();
    }
  }
})
class ModalShipmentV4 extends Vue.with(Props) {
  declare $refs: {
    goodsPackageRef: any;
  };

  bookingFormV4 = this.createBookingFormV4();
  lastExchangeRateContextSignature = "";
  showReceiptFormatMenu = false;

  private createBookingFormV4(isInternational = false): CreateBookingV4 {
    return new CreateBookingV4({
      sender: new SenderBookingV4({
        originCity: `${this.districtDetail.name}, ${this.districtDetail.cityName}`
      }),
      receiver: new ReceiverBookingV4({
        phoneCode: !this.isAccountForeignPos ? "+62" : "+60",
        phoneFlag: !this.isAccountForeignPos ? "indonesia" : "malaysia"
      }),
      pieces: [this.newPiece()],
      commodityCipl: isInternational
        ? [
            new CommodityCiplBookingV4({
              id: 1,
              quantity: "0",
              goodsPrice: "0"
            })
          ]
        : []
    });
  }

  errors = new ErrorBookingV4();
  formCompletionSectionKeyV4 = FormCompletionSectionKeyV4;

  estimationLoading = false;
  estimationIsError = false;
  estimationRequestId = 0;

  hasPickedProductNameManually = false;
  carryOverProductName: string | null = null;
  // Tracks whether protection was disabled on the previous derive pass
  // (initialised true so the first enabled pass seeds Business Rules default
  // protectionChecked=true without clobbering a later manual uncheck).
  previousProtectionDisabled = true;

  productUpsellingData: PosterProduct[] = [];
  productUpsellingLoading = false;
  productUpsellingIsError = false;
  errorRouteNotFound = false;
  agentDiscountRevealed = true;
  fetchPromisesAfterGetUpselling: string[] = [];

  senderCountryIndex = 1;
  senderNameIndex = 2;
  senderPhoneIndex = 3;
  senderAddressIndex = 4;
  receiverCountryIndex = 5;
  receiverNameIndex = 6;
  receiverPhoneIndex = 7;
  receiverAddressIndex = 8;
  receiverDistrictIndex = 9;
  receiverPostalCodeIndex = 10;
  currentIndex = -1;

  readonly maxGoodsPieces = 15;
  dutyTaxResolveResult: DutyTaxResolveResult | null = null;

  commodityUserOverride = false;
  ciplCommodityOptions: CommodityBookingV4[] = [];
  commoditySearchResults: CommodityBookingV4[] = [];
  commodityRecommendations: CommodityBookingV4[] = [];
  commodityListLoading = false;
  commodityListPage = 1;
  commodityListTotalData = 0;

  modalSearchResults: CommodityBookingV4[] = [];
  commodityModalLoading = false;
  commodityModalPage = 1;
  commodityModalTotalData = 0;

  commodityCategories: CommodityCategoryV4[] = [];
  commodityCategoryItems: CommodityBookingV4[] = [];
  selectedCategoryCode: string | null = null;
  commodityModalLoadingCategory = false;

  heavyWeightSurchargeConfig = new HeavyWeightSurchargeData();
  heavyWeightSurchargeConfigBigpack = new HeavyWeightSurchargeData();
  heavyWeightSurchargeMinimumConfig = new HwsThresholdConfig();
  tempProductName = "";

  isSenderSectionValid = false;
  isReceiverSectionValid = false;
  isReferenceSectionValid = false;
  isCommoditySectionValid = false;
  isPackageWeightSectionValid = false;
  isCiplSectionValid = false;
  isSupportingDocSectionValid = false;
  supportingDocFieldRules: Partial<
    Record<SupportingDocCompletionFieldKey, SttAdjustmentRule>
  > = {};
  supportingDocFieldRulesReady = false;
  supportingDocRulesRequestId = 0;
  configurationRules: ProductConfigurationRule[] = [];

  hasAttemptedSubmit = false;
  isLimitTagihanInsufficient = false;

  confirmClose = false;
  loadingForm = false;

  ccoCodActive = new DetailCodConfigurationRetail();
  ccoDfodActive = new DetailCodConfigurationRetail();
  configCodInternationalClient = new DetailCodConfigurationRetail();
  insuranceData = new Insurance();
  readonly woodpackingAdditionalWeightPercentage = 0;
  readonly woodpackingMinAdditionalCwKg = 0;
  clientIdBranch = 0;

  get shipmentDetail(): ShipmentIdTable {
    return this.data[this.selectedIndex] || new ShipmentIdTable();
  }

  get shipmentInsuranceType(): "basic" | "free" {
    return String(this.shipmentDetail.shipmentInsurance)
      .trim()
      .toLowerCase() === "basic"
      ? "basic"
      : "free";
  }

  get receiptFormatOptions(): { value: ReceiptFormatV4Value; label: string }[] {
    return [
      {
        value: ReceiptFormatV4.A6,
        label: this.$t("bookingV4.header.receiptFormat.a6") as string
      },
      {
        value: ReceiptFormatV4.A4,
        label: this.$t("bookingV4.header.receiptFormat.a4") as string
      },
      {
        value: ReceiptFormatV4.NONE,
        label: this.$t("bookingV4.header.receiptFormat.none") as string
      }
    ];
  }

  get activeReceiptFormatLabel(): string {
    const found = this.receiptFormatOptions.find(
      (option) => option.value === this.receiptFormat
    );
    return found
      ? found.label
      : (this.$t("bookingV4.header.receiptFormat.title") as string);
  }

  get visible(): boolean {
    return this.modelValue;
  }

  set visible(val: boolean) {
    if (!val) {
      this.confirmClose = true;
      return;
    }
    this.$emit("update:modelValue", val);
  }

  onCloseForm(): void {
    this.$emit("update:modelValue", false);
    this.confirmClose = false;
  }

  get isBookingRetail(): boolean {
    return this.accountType !== "client";
  }

  get isSuperAdminBooking(): boolean {
    return AccountController.accountData.isPosParentAccount;
  }

  get partnerIsAllowBookVippack(): boolean {
    return (
      AccountController.accountData.account_type_detail
        ?.partnerIsAllowBookVippack ?? false
    );
  }

  get isPriceMasked(): boolean {
    return this.isTokopediaPrefix || this.isCorporatePrefix;
  }

  get isLockedProductContext(): boolean {
    return (
      !this.isShipmentFavorite
    );
  }

  get isAgentDiscountRevealed(): boolean {
    // GENESIS-23375 — Fixing ini mungkin impact ke Shipment CA prefix
    // AG/AD/ARA/ARB/AP/AS. Minta tolong cek harga tetap tampil dan diskon termasking.
    const shouldMaskShipmentCaDiscount = this.validationPrefix([
      "AG",
      "AD",
      "ARA",
      "ARB",
      "AP",
      "AS"
    ]);
    if (this.isLockedProductContext || shouldMaskShipmentCaDiscount)
      return false;
    return this.agentDiscountRevealed;
  }

  get productCardItems(): ProductCardItem[] {
    const { list, upselling } = this.reorderProductTypes;
    const hasRecommended = upselling.some((p) => p.isRecommended);
    const isLockedContext = this.isLockedProductContext;

    return list
      .map((type) => {
        const poster = upselling.find(
          (item) => item.productType.toUpperCase() === type.toUpperCase()
        );
        if (!poster)
          return new PosterProduct({
            productType: type,
            isRecommended: !hasRecommended && type.toUpperCase() === "BOSSPACK"
          });

        const isRecommended = !hasRecommended
          ? poster.productType.toUpperCase() === "BOSSPACK"
          : Boolean(poster.isRecommended) && this.isBookingRetail;

        const slaParts = (poster.estimateSla || "")
          .replace(/\s*Hari\s*/i, "")
          .split("-")
          .map((s) => parseInt(s.trim(), 10));
        const slaMinDays = Number.isFinite(slaParts[0]) ? slaParts[0] : 0;
        const slaMaxDays = Number.isFinite(slaParts[1])
          ? slaParts[1]
          : slaMinDays;

        const disabledProduct =
          this.configRule.productType.rule ===
            ConfigValidationForm.NON_EDITABLE &&
          this.bookingFormV4.product.productType !==
            poster.productType.toUpperCase();

        return {
          productType: poster.productType.toUpperCase(),
          isAvailable: isLockedContext
            ? true
            : poster.totalTariff != null &&
              poster.totalTariff > 0 &&
              !disabledProduct,
          hidePricingData: isLockedContext,
          isEmbargo: poster.isEmbargo ?? false,
          isRecommended,
          shippingCost: poster.totalTariff ?? null,
          slaMinDays,
          slaMaxDays,
          commissionRate: poster.commissionRate ?? 0,
          commissionAmount: poster.bookingCommission ?? 0,
          showMinWeightNote:
            poster.productType === "BIGPACK" ||
            poster.productType === "BIGPACKFAST"
        } as ProductCardItem;
      })
      .filter((item): item is ProductCardItem => item !== null);
  }

  get listProducts(): string[] {
    let products: string[] =
      this.formAccountNumericLocale === "my"
        ? FlagsPermissionBookingV3.config_upselling_product_list.getValue()
            .countries.MY.shipment
        : FlagsPermissionBookingV3.config_upselling_product_list.getValue()
            .shipment;

    if (!FlagsPermissionBooking.config_show_bigpack_fast.isEnabled) {
      products = products.filter((product) => product !== "BIGPACKFAST");
    }

    return products.filter(
      (product) => !["ONEPACK", "VIPPACK"].includes(product.toUpperCase())
    );
  }

  get reorderProductTypes() {
    const listProduct = this.listProducts;
    let upselling = this.productUpsellingData;

    const isInternationalTab = this.activeTab === BookingTabV4.INTERNATIONAL;
    // Daftar produk per tab dikonfigurasi via Unleash BCS
    // config_product_by_type_shipment, dikunci per negara (ID/MY).
    const productByType = FlagsPermissionBookingV4.config_product_by_type_shipment.getValue();
    const countryConfig =
      productByType[this.formAccountNumericLocale.toUpperCase()] ??
      productByType.ID ??
      {};
    const domesticTypes = new Set<string>(countryConfig.domestic ?? []);
    const internationalTypes = new Set<string>(countryConfig.international ?? []);

    upselling = upselling.filter((item) => {
      const type = item.productType.toUpperCase();
      if (isInternationalTab) return internationalTypes.has(type);
      return domesticTypes.has(type);
    });

    if (!this.partnerIsAllowBookVippack || !this.isBookingRetail) {
      upselling = upselling.filter(
        (item) => item.productType.toUpperCase() !== "VIPPACK"
      );
    }

    const filteredListProduct = listProduct.filter((p) => {
      if (isInternationalTab) {
        return internationalTypes.has(p);
      }
      return domesticTypes.has(p);
    });

    const orderedTypes = applyRecommendationOrder(
      filteredListProduct,
      upselling
    );

    return {
      list: orderedTypes,
      upselling
    };
  }

  onProductTypeSelect(productType: string): void {
    this.bookingFormV4.product.productType = productType;
    this.hasPickedProductNameManually = true;
  }

  onAgentDiscountRevealedUpdate(value: boolean): void {
    this.agentDiscountRevealed = value;
  }

  async onProductUpsellingRetry(): Promise<void> {
    await this.fetchProductUpselling();
  }

  async fetchProductUpselling(): Promise<void> {

    if (this.isTokopediaPrefix || !this.isShipmentFavorite) {
      this.productUpsellingData = [
        new PosterProduct({
          productType: this.bookingFormV4.product.productType
        })
      ];
      return;
    }

    const destination = this.destinationCityDetail;
    if (!destination?.id) return;

    this.productUpsellingLoading = true;
    this.productUpsellingIsError = false;
    this.errorRouteNotFound = false;


    try {
      const resp = await BookingV4Controller.postToGetPosterProduct(
        this.upsellingPayload
      );
      this.productUpsellingData = resp.map(
        (product: any) =>
          new PosterProduct({
            productType: product.name,
            estimateSla: product.sla,
            totalTariffAfterDiscount: product.total_tariff_after_discount,
            commissionRate: product.commission_rate,
            bookingCommission: product.booking_commission,
            isEmbargo: product.is_embargo,
            shippingCost: product.shipping_cost,
            isRecommended: Boolean(product.is_recommended),
            publishRate: product.publish_rate ?? 0,
            shippingSurchargeRate: product.shipping_surcharge_rate ?? 0,
            forwardRates: product.forward_rates ?? 0,
            totalTariff: product.total_tariff ?? 0
          })
      );
      if (!resp.length) return;
      const { list } = this.reorderProductTypes;
      if (!list.length) return;
      const hasRecommended = resp.some((p) => p.isRecommended);
      const availableTypes = resp
        .filter((p) => list.includes(p.name.toUpperCase()))
        .map((p: any) => p.name);
      const sortedAvailableTypes = [...availableTypes].sort(
        (a, b) => list.indexOf(a.toUpperCase()) - list.indexOf(b.toUpperCase())
      );
      this.bookingFormV4.product.productType = resolveSelection(
        list,
        this.bookingFormV4.product.productType,
        this.hasPickedProductNameManually,
        this.carryOverProductName,
        hasRecommended,
        sortedAvailableTypes
      );
      this.fetchPromisesAfterGetUpselling.forEach((fn: any) => {
        (this as any)[fn]();
      });
      this.fetchPromisesAfterGetUpselling = [];
    } catch (err) {
      this.handleErrorUpselling(err);
    } finally {
      this.productUpsellingLoading = false;
    }
  }

  handleErrorUpselling(err: any): void {
    this.productUpsellingData = [];
    this.productUpsellingIsError = err?.response?.status >= 500;
    this.hasPickedProductNameManually = false;
    this.errorRouteNotFound =
      !this.productUpsellingIsError &&
      err?.response?.data?.message?.id ===
        "Harga Shipping Surcharge dan Publish Rate untuk rute yang dipilih tidak tersedia";
    this.bookingFormV4.product.productType = "";
  }

  async mounted() {
    await this.getCountryList();
    this.getHWSConfig();
    this.getRoundingRulesConfig();
    this.getCODConfig();
    this.getInsuranceAvailability();
    // InvoiceLimitController.getInvoiceLimitStatusSummary();
    ProductController.fetchVolumetricDivisors(this.accountCountryCode);
    this.fetchCiplCommodityOptions();
    this.refreshCommodityRecommendations();
    this.fetchCommodityCategories();
    this.syncActiveExchangeRate();
    this.fetchSupportingDocFieldRules();

    if (this.visible) {
      this.initShipmentForm();
    }
  }

  get isCourierRecommendation(): boolean {
    return !!this.shipmentDetail?.dataRaw?.ticket_code;
  }

  get referenceExternal() {
    const { dataRaw, shipmentBookingId, STT } = this.shipmentDetail;

    if (this.isCourierRecommendation)
      return [new ReferenceChipV4({ value: dataRaw.ticket_code })];
    if (shipmentBookingId.startsWith("TSLP"))
      return [new ReferenceChipV4({ value: shipmentBookingId })];
    if (STT?.sttNoRefExternal)
      return [new ReferenceChipV4({ value: STT?.sttNoRefExternal })];
    return [];
  }

  get renderPieces(): PieceBookingV4[] {
    const { shipmentGoodDetail } = this.shipmentDetail;
    const normalizeDimension = (value = 10): number => value;

    if (!shipmentGoodDetail || !shipmentGoodDetail.length) {
      const length = normalizeDimension(3);
      const width = normalizeDimension(20);
      const height = normalizeDimension(10);

      const volumeWeight =
        (length * width * height) / this.volumeWeightDivisorForSelectedProduct;

      return [
        new PieceBookingV4({
          grossWeight: 0,
          length,
          width,
          height,
          volumeWeight,
          error: new ErrorPiecesBookingV4()
        })
      ];
    }

    return shipmentGoodDetail
      .filter((item) => item?.shipment_goods_weight)
      .map((item) => {
        const length = normalizeDimension(item.shipment_goods_length);
        const width = normalizeDimension(item.shipment_goods_width);
        const height = normalizeDimension(item.shipment_goods_height);

        const volumeWeight =
          (length * width * height) /
          this.volumeWeightDivisorForSelectedProduct;

        return new PieceBookingV4({
          grossWeight: item.shipment_goods_weight || 0,
          length,
          height,
          width,
          volumeWeight
        });
      });
  }

  async initShipmentForm(): Promise<void> {
    if (!this.data.length || !this.shipmentDetail) return;

    this.loadingForm = true;
    try {
      const d = this.shipmentDetail;
      const isAPASPrefix = ["AP", "AS"].some((e) =>
        d.shipmentAlgoId.startsWith(e)
      );
      const shipmentProduct = String(
        d.shipmentProduct || d.STT?.sttProductType || ""
      ).toUpperCase();

      // origin country based on account not from api based on GENESIS-23767
      const originCountryCode = (
        this.districtDetail.countryCode || ""
      ).toUpperCase();
      const destinationCountryCode = (
        d.shipmentDestinationDistrict?.country_code || ""
      ).toUpperCase();

      const isInternational =
        !isAPASPrefix &&
        !!destinationCountryCode &&
        originCountryCode !== destinationCountryCode;

      const activeTab = isInternational
        ? BookingTabV4.INTERNATIONAL
        : BookingTabV4.DOMESTIC;
      const ciplDetail = d.STT?.sttCipl;
      const rawSttCipl = d.STT?.sttcipl;
      const rawCipl = Array.isArray(rawSttCipl) ? rawSttCipl : [];
      const ciplItems = (ciplDetail?.listCommodityCIPL || []).map(
        (item, index) =>
          new CommodityCiplBookingV4({
            id: index + 1,
            name: item.commodity?.name || item.name || "",
            quantity: String(item.quantity || 1),
            goodsPrice: String(item.goodsPrice || 0),
            commodityId: item.commodity?.id || 0,
            code: item.commodity?.code || item.name || "",
            hsCode:
              item.commodity?.hsCode || rawCipl[index]?.commodity_hs_code || "",
            status: item.commodity?.status || "",
            isDangerousGoods: Boolean(item.commodity?.isDangerousGoods),
            isQuarantine: Boolean(item.commodity?.isQuarantine)
          })
      );
      const commodityCipl = isInternational
        ? ciplItems.length
          ? ciplItems
          : [
              new CommodityCiplBookingV4({
                id: 1,
                quantity: "0",
                goodsPrice: "0"
              })
            ]
        : [];

      const originCountry = new CountryData(
        this.countryList.find(
          (item: CountryData) => item.code === d.shipmentOriginCountryCode
        )
      );

      const destinationCountry = new CountryData(
        this.countryList.find(
          (item: CountryData) =>
            item.code === d.shipmentDestinationDistrict?.country_code
        )
      );

      const form = new CreateBookingV4({
        pageMeta: new PageMetaBookingV4({ activeTab }),
        sender: new SenderBookingV4({
          name: d.shipmentSenderName || "",
          phoneCode: d.shipmentSenderPhoneCode || "+62",
          phone: d.shipmentSenderPhone || "",
          address: d.shipmentSenderAddress || "",
          originCity: `${this.districtDetail.name}, ${this.districtDetail.cityName}`,
          originCountryCode: isAPASPrefix
            ? ""
            : this.districtDetail.countryCode,
          originCountry
        }),
        receiver: new ReceiverBookingV4({
          destinationCountryCode:
            d.shipmentDestinationDistrict?.country_code || "",
          name: d.shipmentRecipientName || "",
          phoneCode:
            d.shipmentRecipientPhoneCode ||
            (!this.isAccountForeignPos ? "+62" : "+60"),
          phone: d.shipmentRecipientPhone || "",
          address: d.shipmentRecipientAddress || "",
          phoneFlag: !this.isAccountForeignPos ? "indonesia" : "malaysia",
          postalCode: d.postalCodeDestination || "",
          destinationCountry
        }),
        references: this.referenceExternal,
        commodity: new CommodityBookingV4({
          id: d.shipmentCommodityId,
          name:
            typeof d.shipmentCommodityName === "string"
              ? d.shipmentCommodityName
              : (d.shipmentCommodityName as any)?.name || "",
          code:
            typeof d.shipmentCommodityCode === "string"
              ? d.shipmentCommodityCode
              : (d.shipmentCommodityCode as any)?.code ||
                (d.shipmentCommodityCode as any)?.value ||
                ""
        }),
        product: new ProductBookingV4({
          productType: shipmentProduct
        }),
        protectionPacking: new ProtectionPackingBookingV4({
          itemPrice:
            Number(
              String(d.shipmentGoodsPriceEstimation || 0).replace(/[.]/g, "")
            ) || 0,
          woodpacking: Boolean(d.shipmentIsWoodpacking),
          woodpackingEligible: true,
          insuranceType: this.shipmentInsuranceType,
          protectionChecked: this.shipmentInsuranceType === "basic"
        }),
        commodityCipl,
        supportingDoc: new SupportingDocBookingV4({
          docInternational: new DocInternationalBookingV4({
            listCommodityCipl: ciplItems,
            email: ciplDetail?.email || "",
            idNumber: ciplDetail?.idNumber || "",
            taxNumber: ciplDetail?.taxNumber || "",
            imageBeforePackingUrl: ciplDetail?.imageBeforePackingUrl || "",
            imageAfterPackingUrl: ciplDetail?.imageAfterPackingUrl || "",
            imageIdUrl: ciplDetail?.imageIdUrl || "",
            imageTaxUrl: ciplDetail?.imageTaxUrl || "",
            dutyTaxTerms: "DAP"
          })
        }),
        shipmentId: d.shipmentAlgoId
      });

      Object.assign(this.bookingFormV4, form);

      if (d.shipmentProduct) {
        this.hasPickedProductNameManually = true;
      }

      if (d.shipmentIsDfod) {
        this.bookingFormV4.paymentMethod = new PaymentMethodBookingV4({
          method: PaymentMethodV4.DFOD
        });
      } else if (d.shipmentIsCod) {
        this.bookingFormV4.paymentMethod = new PaymentMethodBookingV4({
          method: PaymentMethodV4.COD,
          codAmount: d.codAmount
        });
      }

      this.syncFavoriteCodAmount();
      // await this.$nextTick();
      this.bookingFormV4.pieces = this.renderPieces;
      this.clientIdBranch = d.shipmentClientIdBranch;

      await this.getDetailDistrict();
      await this.getCODConfig();

      if (
        this.isApAsRouteCodDisabled &&
        this.bookingFormV4.paymentMethod.method !== PaymentMethodV4.CASH
      ) {
        this.bookingFormV4.paymentMethod = new PaymentMethodBookingV4({
          method: PaymentMethodV4.CASH
        });
      }

      this.onSetInsurance();
      this.initAdjustmentStt();
      if (!this.isShipmentFavorite) this.validateErrorPrice();
      await this.fetchProductUpselling();

      this.originalChWeight = cloneDeep(
        this.chargeableWeightBreakdown.finalCwKg
      );
    } catch (err) {
      // fallback
    } finally {
      this.loadingForm = false;
    }
  }

  async getDetailDistrict(): Promise<void> {
    const { shipmentDestinationDistrict } = this.shipmentDetail;

    LocationController.setZipCodeData(
      new ZipCodeEntities(new Pagination(1, 20), [])
    );

    if (!shipmentDestinationDistrict?.code) {
      LocationController.setEmptyDestinationDistrict();
      return;
    }

    try {
      await LocationController.getDetailDistrictByDistrictCode({
        districtCode: shipmentDestinationDistrict.code
      });

      const districtDetail = LocationController.destinationDistrict;
      this.bookingFormV4.receiver.destinationCity = new DistrictData(
        districtDetail
      );

      const zipCodeList = (districtDetail.destinationListZipCode || [])
        .filter((item: any) => item)
        .map(
          (item: any) =>
            new DistrictData({
              id: item,
              name: item,
              destinationZipCode: item
            })
        );
      LocationController.setZipCodeData(
        new ZipCodeEntities(new Pagination(1, 20), zipCodeList)
      );
      this.initAdjustmentStt();
    } catch {
      // ignore
    }
  }

  resetFormToDefault(): void {
    this.bookingFormV4 = this.createBookingFormV4();
    this.errors = new ErrorBookingV4();
    this.currentIndex = -1;
    this.hasAttemptedSubmit = false;
    this.isLimitTagihanInsufficient = false;
    this.dutyTaxResolveResult = null;
  }

  onActiveTabUpdate(value: BookingTabV4Value): void {
    this.resetFormByTab(value);
  }

  resetFormByTab(value: BookingTabV4Value): void {
    const isInternational = value === "international";

    Object.assign(
      this.bookingFormV4,
      this.createBookingFormV4(isInternational)
    );
    this.errors = new ErrorBookingV4();
    this.dutyTaxResolveResult = null;

    this.bookingFormV4.pageMeta.activeTab = value;

    this.senderCountryIndex = 1;
    this.senderNameIndex = 2;
    this.senderPhoneIndex = 3;
    this.senderAddressIndex = 4;
    this.receiverCountryIndex = 5;
    this.receiverNameIndex = 6;
    this.receiverPhoneIndex = 7;
    this.receiverAddressIndex = 8;
    this.receiverDistrictIndex = isInternational ? 10 : 9;
    this.receiverPostalCodeIndex = isInternational ? 9 : 10;

    this.isSenderSectionValid = false;
    this.isReceiverSectionValid = false;
    this.isReferenceSectionValid = false;
    this.isCommoditySectionValid = false;
    this.isPackageWeightSectionValid = false;
    this.isCiplSectionValid = false;
    this.isSupportingDocSectionValid = false;

    this.supportingDocFieldRules = {};
    this.supportingDocFieldRulesReady = false;
    this.supportingDocRulesRequestId++;

    this.hasAttemptedSubmit = false;
    this.isLimitTagihanInsufficient = false;

    this.commodityUserOverride = false;
    this.commoditySearchResults = [];
    this.commodityListPage = 1;
    this.commodityListTotalData = 0;

    this.modalSearchResults = [];
    this.commodityModalPage = 1;
    this.commodityModalTotalData = 0;
    this.selectedCategoryCode = null;
    this.commodityCategoryItems = [];

    this.productUpsellingData = [];
    this.productUpsellingLoading = false;
    this.productUpsellingIsError = false;
    this.errorRouteNotFound = false;
    this.agentDiscountRevealed = false;

    this.carryOverProductName = null;
    this.previousProtectionDisabled = true;
    this.currentIndex = -1;

    BookingV4Controller.clearActiveExchangeRate();

    this.fetchSupportingDocFieldRules();
  }

  onReceiptFormatUpdate(value: ReceiptFormatV4Value): void {
    this.bookingFormV4.pageMeta.receiptFormat = value;
  }

  onSenderUpdate(value: CreateBookingV4): void {
    this.bookingFormV4 = value;
  }

  onReceiverUpdate(value: CreateBookingV4): void {
    this.bookingFormV4 = value;
    void this.syncActiveExchangeRate();
  }

  onSenderValidationChange(valid: boolean): void {
    this.isSenderSectionValid = valid;
  }

  onReceiverValidationChange(valid: boolean): void {
    this.isReceiverSectionValid = valid;
  }

  onSupportingDocUpdate(value: SupportingDocBookingV4): void {
    this.bookingFormV4.supportingDoc = value;
  }

  onSupportingDocValidationChange(valid: boolean): void {
    this.isSupportingDocSectionValid =
      this.supportingDocFieldRulesReady && valid;
  }

  onReferencesUpdate(value: ReferenceChipV4[]): void {
    this.bookingFormV4.references = value;
  }

  onReferenceValidationChange(valid: boolean): void {
    this.isReferenceSectionValid = valid;
  }

  onSectionCurrentIndexUpdate(index: number): void {
    this.currentIndex = index;
  }

  get isErrorEmbargoDestination(): boolean {
    return (
      this.productUpsellingData.length > 0 &&
      this.productUpsellingData.every((item) => item.isEmbargo) &&
      !!this.bookingFormV4.receiver.destinationCity
    );
  }

  async onAutofillCommodity(): Promise<void> {
    await this.refreshCommodityRecommendations();
    this.validateCommodityActive(this.bookingFormV4.commodity);
    this.commodityUserOverride = false;
  }

  mapCommodityListToBookingV4(list: Commodity[]): CommodityBookingV4[] {
    return list.map(
      (item) =>
        new CommodityBookingV4({
          id: item.commodity_id,
          name: item.commodity_name,
          nameEn: item.commodity_name_en,
          code: item.commodity_code,
          isDangerousGoods: item.isDangerousGoods,
          isQuarantine: item.isQuarantine,
          status: item.commodity_status
        })
    );
  }

  validateCommodityActive(commodity: CommodityBookingV4): void {
    const isInactive =
      !!commodity.id && !!commodity.status && commodity.status !== "active";
    this.errors.commodity = isInactive
      ? (this.$t("bookingV4.goods.commodity.errorInactive") as string)
      : "";
  }

  async fetchCiplCommodityOptions(): Promise<void> {
    try {
      const resp = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          limit: 100,
          countryCode: this.accountCountryCode.toUpperCase(),
          commodityStatus: "active"
        })
      );
      this.ciplCommodityOptions = this.mapCommodityListToBookingV4(resp.data);
    } catch (error) {
      this.ciplCommodityOptions = [];
    }
  }

  async refreshCommodityRecommendations(): Promise<void> {
    try {
      const resp = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          isRecommendedOnly: true,
          limit: 6,
          countryCode: this.accountCountryCode.toUpperCase(),
          commodityStatus: "active"
        })
      );
      this.commodityRecommendations = this.mapCommodityListToBookingV4(
        resp.data
      ).slice(0, 6);
    } catch (error) {
      this.commodityRecommendations = [];
    }
  }

  async fetchCommodityCategories(): Promise<void> {
    try {
      const categories = await CommodityController.getCommodityCategory(
        this.accountCountryCode.toUpperCase()
      );
      this.commodityCategories = categories.map(
        (item) =>
          ({
            code: item.commodityCategoryCode,
            name: item.commodityCategoryNameId,
            nameEn: item.commodityCategoryNameEn
          } as CommodityCategoryV4)
      );
    } catch (error) {
      this.commodityCategories = [];
    }
  }

  get commodityListHasMore(): boolean {
    return this.commodityListPage * 20 < this.commodityListTotalData;
  }

  async searchCommodity(keyword: string): Promise<void> {
    this.commodityListLoading = true;
    try {
      const resp = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          search: keyword,
          page: 1,
          limit: 20,
          countryCode: this.accountCountryCode.toUpperCase(),
          commodityStatus: "active"
        })
      );
      this.commoditySearchResults = this.mapCommodityListToBookingV4(resp.data);
      this.commodityListPage = 1;
      this.commodityListTotalData = resp.pagination.totalData || 0;
    } catch (error) {
      this.commoditySearchResults = [];
      this.commodityListTotalData = 0;
    } finally {
      this.commodityListLoading = false;
    }
  }

  async loadMoreCommodities(keyword: string): Promise<void> {
    if (!this.commodityListHasMore || this.commodityListLoading) return;
    this.commodityListLoading = true;
    try {
      const nextPage = this.commodityListPage + 1;
      const resp = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          search: keyword,
          page: nextPage,
          limit: 20,
          countryCode: this.accountCountryCode.toUpperCase(),
          commodityStatus: "active"
        })
      );
      this.commoditySearchResults = [
        ...this.commoditySearchResults,
        ...this.mapCommodityListToBookingV4(resp.data)
      ];
      this.commodityListPage = nextPage;
      this.commodityListTotalData = resp.pagination.totalData || 0;
    } catch (error) {
      // ignore
    } finally {
      this.commodityListLoading = false;
    }
  }

  get commodityModalHasMore(): boolean {
    return this.commodityModalPage * 20 < this.commodityModalTotalData;
  }

  async searchCommodityModal(keyword: string): Promise<void> {
    this.commodityModalLoading = true;
    this.selectedCategoryCode = null;
    this.commodityCategoryItems = [];
    try {
      const resp = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          search: keyword,
          page: 1,
          limit: 20,
          countryCode: this.accountCountryCode.toUpperCase(),
          commodityStatus: "active"
        })
      );
      this.modalSearchResults = this.mapCommodityListToBookingV4(resp.data);
      this.commodityModalPage = 1;
      this.commodityModalTotalData = resp.pagination.totalData || 0;
    } catch (error) {
      this.modalSearchResults = [];
      this.commodityModalTotalData = 0;
    } finally {
      this.commodityModalLoading = false;
    }
  }

  async loadMoreCommodityModal(keyword: string): Promise<void> {
    if (!this.commodityModalHasMore || this.commodityModalLoading) return;
    this.commodityModalLoading = true;
    try {
      const nextPage = this.commodityModalPage + 1;
      const resp = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          search: keyword,
          page: nextPage,
          limit: 20,
          countryCode: this.accountCountryCode.toUpperCase(),
          commodityStatus: "active"
        })
      );
      this.modalSearchResults = [
        ...this.modalSearchResults,
        ...this.mapCommodityListToBookingV4(resp.data)
      ];
      this.commodityModalPage = nextPage;
      this.commodityModalTotalData = resp.pagination.totalData || 0;
    } catch (error) {
      // ignore
    } finally {
      this.commodityModalLoading = false;
    }
  }

  async selectCommodityCategory(code: string): Promise<void> {
    this.selectedCategoryCode = code;
    this.commodityModalLoadingCategory = true;
    try {
      const resp = await BookingV4Controller.getCommodityList(
        new RequestListCommodityV4({
          commodityCategoryCode: code,
          page: 1,
          limit: 100,
          countryCode: this.accountCountryCode.toUpperCase(),
          commodityStatus: "active"
        })
      );
      this.commodityCategoryItems = this.mapCommodityListToBookingV4(resp.data);
    } catch (error) {
      this.commodityCategoryItems = [];
    } finally {
      this.commodityModalLoadingCategory = false;
    }
  }

  onCommodityCiplUpdate(value: CommodityCiplBookingV4[]): void {
    this.bookingFormV4.commodityCipl = value;
  }

  onCommodityError(errorMessage: string): void {
    this.errors.commodity = errorMessage;
  }

  get commodityCiplPrefillSignature(): string {
    return this.bookingFormV4.commodityCipl
      .map((row) => `${row.id}:${row.commodityId}:${row.name}`)
      .join("|");
  }

  applyCommodityPrefillRules(): void {
    const resolved = this.bookingFormV4.commodityCipl
      .map((row) => this.resolveCiplRowCommodity(row))
      .filter((item): item is CommodityBookingV4 => item !== null);

    if (!resolved.length) return;

    const dgGroup = resolved.filter((item) => item.isDangerousGoods);
    const nonDgGroup = resolved.filter((item) => !item.isDangerousGoods);
    const winner = this.pickMajorityCommodity(
      dgGroup.length ? dgGroup : nonDgGroup
    );
    if (winner) this.setPrefillCommodity(winner);
  }

  resolveCiplRowCommodity(
    row: CommodityCiplBookingV4
  ): CommodityBookingV4 | null {
    if (!row.commodityId || row.commodityId <= 0) return null;
    return (
      this.ciplCommodityOptions.find((item) => item.id === row.commodityId) ||
      null
    );
  }

  pickMajorityCommodity(
    group: CommodityBookingV4[]
  ): CommodityBookingV4 | null {
    if (!group.length) return null;
    const countByCode = new Map<string, number>();
    const firstIndexByCode = new Map<string, number>();
    group.forEach((item, index) => {
      countByCode.set(item.code, (countByCode.get(item.code) || 0) + 1);
      if (!firstIndexByCode.has(item.code)) {
        firstIndexByCode.set(item.code, index);
      }
    });

    let bestCode = "";
    let bestCount = -1;
    let bestFirstIndex = Infinity;
    countByCode.forEach((count, code) => {
      const firstIndex = firstIndexByCode.get(code) ?? Infinity;
      if (
        count > bestCount ||
        (count === bestCount && firstIndex < bestFirstIndex)
      ) {
        bestCode = code;
        bestCount = count;
        bestFirstIndex = firstIndex;
      }
    });

    return group.find((item) => item.code === bestCode) || null;
  }

  setPrefillCommodity(commodity: CommodityBookingV4): void {
    this.bookingFormV4.commodity = new CommodityBookingV4(commodity);
    this.commodityUserOverride = false;
  }

  onCommodityUpdate(value: CommodityBookingV4 | null): void {
    this.bookingFormV4.commodity = value || new CommodityBookingV4();
    this.commodityUserOverride = true;
  }

  onPiecesUpdate(value: PieceBookingV4[]): void {
    this.bookingFormV4.pieces = value;
  }

  newPiece(): PieceBookingV4 {
    const length = 3;
    const width = 20;
    const height = 10;
    return new PieceBookingV4({
      length,
      width,
      height,
      grossWeight: 0,
      volumeWeight: this.computeVolumeWeight(length, width, height),
      error: new ErrorPiecesBookingV4()
    });
  }

  computeVolumeWeight(length: number, width: number, height: number): number {
    if (!this.volumeWeightDivisorForSelectedProduct) return 0;
    return (
      (length * width * height) / this.volumeWeightDivisorForSelectedProduct
    );
  }

  onGoodsPackageReset(): void {
    this.bookingFormV4.commodityCipl = [];
    this.bookingFormV4.commodity = new CommodityBookingV4();
    this.bookingFormV4.pieces = [this.newPiece()];
    this.bookingFormV4.commodityCipl = this.showItemDetails
      ? [
          new CommodityCiplBookingV4({
            id: 1,
            quantity: "0",
            goodsPrice: "0"
          })
        ]
      : [];
    this.commodityUserOverride = false;
    this.errors.commodity = "";
    this.errors.pieces = "";
    this.isCiplSectionValid = !this.showItemDetails;
    this.isCommoditySectionValid = false;
    this.isPackageWeightSectionValid = false;
  }

  onCiplValidationChange(isValid: boolean): void {
    this.isCiplSectionValid = isValid;
  }

  onCommodityValidationChange(isValid: boolean): void {
    this.isCommoditySectionValid = isValid;
  }

  onPackageWeightValidationChange(isValid: boolean): void {
    this.isPackageWeightSectionValid = isValid;
  }

  get exchangeRatePairSignature(): string {
    return `${this.formAccountCurrencyCode}|${this.formLocalCurrencyCode}|${
      this.bookingFormV4.receiver.destinationCountryCode
    }|${this.destinationCityDetail?.id || ""}`;
  }

  async syncActiveExchangeRate(): Promise<void> {
    const from = this.formAccountCurrencyCode;
    const to = this.formLocalCurrencyCode;
    const destinationCountryCode = this.bookingFormV4.receiver
      .destinationCountryCode;
    const destinationCityId = this.destinationCityDetail?.id || 0;
    const contextSignature = this.exchangeRatePairSignature;
    if (contextSignature === this.lastExchangeRateContextSignature) return;
    this.lastExchangeRateContextSignature = contextSignature;
    if (!destinationCountryCode || !destinationCityId || from === to) {
      await BookingV4Controller.clearActiveExchangeRate();
      return;
    }
    const result = await BookingV4Controller.fetchActiveExchangeRate({
      from,
      to
    });
    if (!result) this.lastExchangeRateContextSignature = "";
  }

  get ciplLocalTotal(): number {
    return this.bookingFormV4.commodityCipl.reduce((total, item) => {
      return (
        total +
        parseCiplNumber(item.quantity) * parseCiplNumber(item.goodsPrice)
      );
    }, 0);
  }

  get activeCiplExchangeRate(): number | null {
    const rate = BookingV4Controller.activeExchangeRate;
    const from = this.formAccountCurrencyCode;
    const to = this.formLocalCurrencyCode;
    const isValid = Boolean(
      rate &&
        rate.exchangeRateFrom === from &&
        rate.exchangeRateTo === to &&
        rate.exchangeRateStatus === "active" &&
        Number.isFinite(rate.exchangeRate) &&
        rate.exchangeRate > 0
    );
    return isValid && rate ? rate.exchangeRate : null;
  }

  get ciplEstimatedConversion(): { currency: string; amount: number } | null {
    const exchangeRate = BookingV4Controller.activeExchangeRate;
    const rate = this.activeCiplExchangeRate;
    const estimatedConversion =
      rate !== null && exchangeRate
        ? {
            currency: exchangeRate.exchangeRateTo,
            amount: this.ciplLocalTotal * rate
          }
        : null;
    return estimatedConversion;
  }

  get ENABLE_DUTY_TAX_INFOBAR(): boolean {
    return this.isB1APAS && this.isCipl;
  }

  get ciplDeminimisThreshold(): number | null {
    if (!this.ENABLE_DUTY_TAX_INFOBAR || !this.dutyTaxResolveResult) {
      return null;
    }
    return this.dutyTaxResolveResult.deminimisValue;
  }

  get dutyTaxDestinationCurrency(): string {
    if (!this.ENABLE_DUTY_TAX_INFOBAR || !this.dutyTaxResolveResult) {
      return "";
    }
    return this.dutyTaxResolveResult.destinationCurrencyCode;
  }

  get ciplDeminimisExceeded(): boolean {
    if (!this.ENABLE_DUTY_TAX_INFOBAR || !this.dutyTaxResolveResult) {
      return false;
    }
    return this.dutyTaxResolveResult.deminimisExceeded;
  }

  get recipientImportDocRequired(): boolean {
    if (!this.ENABLE_DUTY_TAX_INFOBAR || !this.dutyTaxResolveResult) {
      return false;
    }
    return this.dutyTaxResolveResult.documentCircularRequired;
  }

  get selfClearanceRequired(): boolean {
    if (!this.ENABLE_DUTY_TAX_INFOBAR || !this.dutyTaxResolveResult) {
      return false;
    }
    return this.dutyTaxResolveResult.selfClearanceRequired;
  }

  get dutyTaxResolveItems(): DutyTaxResolveItemInput[] {
    const rowsByInsertOrder = [...this.bookingFormV4.commodityCipl].sort(
      (a, b) => a.id - b.id
    );
    const groups = new Map<string, DutyTaxResolveItemInput>();
    rowsByInsertOrder.forEach((row, index) => {
      if (!row.commodityId || row.commodityId <= 0) return;
      const commodityCode = row.code;
      if (!commodityCode) return;
      const price =
        parseCiplNumber(row.quantity) *
        parseByCountry(row.goodsPrice, { country: this.accountCountryCode });
      const existing = groups.get(commodityCode);
      if (existing) {
        existing.summedPrice += price;
      } else {
        groups.set(commodityCode, {
          commodityCode,
          summedPrice: price,
          firstInputIndex: index
        });
      }
    });
    return Array.from(groups.values());
  }

  get dutyTaxResolveContextSignature(): string {
    return [
      this.ENABLE_DUTY_TAX_INFOBAR,
      this.bookingFormV4.receiver.destinationCountryCode,
      this.footerChargeableWeightKg,
      this.formAccountCurrencyCode,
      this.dutyTaxResolveItems
        .map(
          (item) =>
            `${item.commodityCode}:${item.summedPrice}:${item.firstInputIndex}`
        )
        .join(",")
    ].join("|");
  }

  getDutyTaxResolveDebounced = debounce(async () => {
    const destinationCountryCode = this.bookingFormV4.receiver
      .destinationCountryCode;
    const chargeableWeightKg = this.footerChargeableWeightKg;
    const items = this.dutyTaxResolveItems;
    if (
      !this.ENABLE_DUTY_TAX_INFOBAR ||
      !destinationCountryCode ||
      !(chargeableWeightKg > 0) ||
      !items.length
    ) {
      this.dutyTaxResolveResult = null;
      return;
    }
    try {
      this.dutyTaxResolveResult = await DutyTaxConfigurationController.resolveDutyTaxConfiguration(
        {
          destinationCountryCode: destinationCountryCode.toUpperCase(),
          chargeableWeightKg,
          originCurrency: this.formAccountCurrencyCode,
          items
        }
      );
    } catch {
      // Never blocks submit — resolve failure/timeout just hides the infobar.
      this.dutyTaxResolveResult = null;
    }
  }, 250);

  get volumeWeightDivisorForSelectedProduct(): number {
    return volumeWeightForProduct(
      this.bookingFormV4?.product?.productType || "",
      ProductController.volumetricDivisorMap,
      this.accountCountryCode
    );
  }

  getHWSConfig = debounce(async () => {
    try {
      const resp = await HeavyWeightSurchargeController.getDetailHeavyWeightSurcharge(
        { id: 1 }
      );
      const respBigpack = await HeavyWeightSurchargeController.getDetailHeavyWeightSurcharge(
        { id: 2 }
      );
      this.heavyWeightSurchargeConfig = resp;
      this.heavyWeightSurchargeConfigBigpack = respBigpack;
    } catch (err) {
      this.heavyWeightSurchargeMinimumConfig = new HwsThresholdConfig();
    }
  }, 500);

  get hwsConfigForSelectedProduct(): HwsThresholdConfig {
    const productName =
      this.bookingFormV4.product.productType || this.tempProductName;
    if (
      !this.heavyWeightSurchargeConfig.configurableHeavyWeight ||
      !this.heavyWeightSurchargeConfigBigpack.configurableHeavyWeight
    )
      return new HwsThresholdConfig();
    const isActive =
      this.heavyWeightSurchargeConfig.configurablePriceStatus.toLowerCase() ||
      this.heavyWeightSurchargeConfigBigpack.configurablePriceStatus.toLowerCase() ===
        "active";
    const product = this.heavyWeightSurchargeConfig.configurableHeavyWeight.heavy_weight_surcharge_product_include.product_types.includes(
      productName.toUpperCase()
    );
    const productBigpack = this.heavyWeightSurchargeConfigBigpack.configurableHeavyWeight.heavy_weight_surcharge_product_include.product_types.includes(
      productName.toUpperCase()
    );
    const isEnableHwsConfig = FlagsPermissionBooking.hws_configuration.isEnabled();
    const commodity = this.heavyWeightSurchargeConfig.configurableHeavyWeight.heavy_weight_surcharge_commodity_exclude.commodities.find(
      (item: any) =>
        item.commodity_code === this.bookingFormV4.commodity.code ||
        item.commodity_name === this.bookingFormV4.commodity.name
    );
    const commodityBigpack = this.heavyWeightSurchargeConfigBigpack.configurableHeavyWeight.heavy_weight_surcharge_commodity_exclude.commodities.find(
      (item: any) =>
        item.commodity_code === this.bookingFormV4.commodity.code ||
        item.commodity_name === this.bookingFormV4.commodity.name
    );

    const otherCondition =
      (product || productBigpack) && (!commodity || !commodityBigpack);
    const isSetMinimumHws = isActive && otherCondition && isEnableHwsConfig;
    if (isSetMinimumHws) {
      return new HwsThresholdConfig({
        minimumWeightKg: productBigpack
          ? this.heavyWeightSurchargeConfigBigpack.configurableHeavyWeight
              .heavy_weight_surcharge_additional_cost.additional_costs[0]
              ?.weight_min
          : this.heavyWeightSurchargeConfig.configurableHeavyWeight
              .heavy_weight_surcharge_additional_cost.additional_costs[0]
              ?.weight_min,
        minimumExist: true
      });
    }

    return new HwsThresholdConfig();
  }

  get receiverSinglePieceOnly(): boolean {
    const district = this.destinationCityDetail;
    if (!district) return false;
    const type = (district.type || "").toLowerCase();
    const vendorCode = (district.vendorCode || "").toLowerCase();
    const isVendorType = type === "vendor" || type === "vendor_lanjutan";
    const isVendorCode =
      vendorCode === "ninja" || vendorCode === "nx" || vendorCode === "pi";
    return isVendorType && isVendorCode;
  }

  get activeTab(): BookingTabV4Value {
    return this.bookingFormV4.pageMeta.activeTab;
  }

  get receiptFormat(): ReceiptFormatV4Value {
    return this.bookingFormV4.pageMeta.receiptFormat;
  }

  get districtDetail(): DistrictData {
    return LocationController.districtDetail;
  }

  get accountIsNonForeign(): boolean {
    return !AccountController.accountData.accountIsForeign;
  }

  get accountCountryCode(): string {
    return AccountController.accountData.countryCode;
  }

  get isFtz(): boolean {
    return AccountController.accountData.account_type === "internal"
      ? this.districtDetail.isFtz === "yes"
      : AccountController.accountData.account_location?.city_free_trade_zone ===
          "yes" && this.accountIsNonForeign;
  }

  get destinationCityDetail(): DistrictData | null {
    const destination = this.bookingFormV4.receiver.destinationCity;
    return typeof destination === "string" ? null : destination;
  }

  get isCipl(): boolean {
    if (
      this.isShipmentFavorite &&
      this.destinationCityDetail?.countryCode &&
      this.accountCountryCode
    ) {
      return (
        this.accountCountryCode.toUpperCase() !==
        this.destinationCityDetail.countryCode.toUpperCase()
      );
    }
    return this.activeTab === BookingTabV4.INTERNATIONAL;
  }

  get isFtzForm(): boolean {
    return this.activeTab === BookingTabV4.DOMESTIC && this.isFtz;
  }

  get showItemDetails(): boolean {
    return this.isCipl || this.isFtzForm;
  }

  get showSupportingDocSection(): boolean {
    return this.isCipl || this.isFtzForm;
  }

  get supportingDocContextSignature(): string {
    return [
      this.districtDetail.cityId,
      this.destinationCityDetail?.cityId || 0,
      this.isCipl,
      this.isFtzForm,
      this.isPosAccount
    ].join("|");
  }

  seedRetailDutyTaxTerms(): void {
    const docInternational = this.bookingFormV4.supportingDoc.docInternational;
    if (!docInternational.dutyTaxTerms) {
      docInternational.dutyTaxTerms = "DAP";
    }
  }

  async getRoundingRulesConfig(): Promise<void> {
    try {
      const resp = await BookingV4Controller.fetchProductConfigurationRule(
        new ProductConfigurationRuleRequestParamsV4({
          page: 1,
          limit: 10,
          isNoLimit: true,
          countryCode: this.accountCountryCode.toUpperCase()
        })
      );
      this.configurationRules = resp || [];
    } catch {
      this.configurationRules = [];
    }
  }

  async fetchSupportingDocFieldRules(): Promise<void> {
    const requestId = ++this.supportingDocRulesRequestId;
    this.supportingDocFieldRulesReady = false;
    this.isSupportingDocSectionValid = false;

    if (!this.showSupportingDocSection) {
      this.supportingDocFieldRules = {};
      return;
    }
    if (this.isFtzForm) {
      this.supportingDocFieldRules = {};
      this.supportingDocFieldRulesReady = true;
      return;
    }

    this.seedRetailDutyTaxTerms();
    const origin = this.districtDetail.cityId;
    const dest = this.destinationCityDetail?.cityId || 0;
    if (!origin || !dest) return;

    try {
      const detail = await InternationalDocumentController.getInternationalDocumentDetail(
        {
          origin,
          dest
        }
      );
      if (requestId !== this.supportingDocRulesRequestId) return;
      this.supportingDocFieldRulesReady = true;
      this.supportingDocFieldRules = this.mapSupportingDocFieldRules(detail);
    } catch (_error) {
      if (requestId !== this.supportingDocRulesRequestId) return;
      this.supportingDocFieldRules = {};
    }
  }

  mapSupportingDocFieldRules(
    detail: RequestInternationalDocumentDetail
  ): Partial<Record<SupportingDocCompletionFieldKey, SttAdjustmentRule>> {
    const rule = (isRequired: boolean) => new SttAdjustmentRule({ isRequired });
    // all cipl field rule for this development phase is harcoded
    // maybe change on next phase
    // return {
    //   email: rule(detail.email),
    //   idNumber: rule(detail.idcIsIdentityNumber),
    //   taxNumber: rule(detail.idcIsTaxIdentificationNumber),
    //   imageId: rule(detail.ktp),
    //   imageTax: rule(detail.npwp),
    //   imageBeforePacking: rule(detail.afterPacking),
    //   imageAfterPacking: rule(detail.afterPacking)
    // };
    return {
      email: rule(false),
      idNumber: rule(false),
      taxNumber: rule(false),
      imageId: rule(false),
      imageTax: rule(false),
      imageBeforePacking: rule(false),
      imageAfterPacking: rule(false)
    };
  }

  get isReferenceRequired(): boolean {
    return this.bookingFormV4.isReferenceRequired;
  }

  get accountType(): AccountTypeV4 {
    if (AccountController.accountData.isInternalAccount) return "internal";
    if (AccountController.accountData.isAllClient) return "client";
    return "pos";
  }

  get isGoodsPiecesSectionValid(): boolean {
    return (
      this.isCommoditySectionValid &&
      this.isPackageWeightSectionValid &&
      !this.isMandatoryUploadProofAdjust &&
      (!this.showItemDetails || this.isCiplSectionValid)
    );
  }

  get shipmentSttDetailPayload(): ShipmentSttDetail {
    const s = this.shipmentDetail;
    const f = this.bookingFormV4;
    const postalCode =
      typeof f.receiver.postalCode === "string"
        ? f.receiver.postalCode
        : f.receiver.postalCode?.destinationZipCode || "";

    const shipmentC1Cod =
      f.shipmentId.startsWith(
        FlagsFeatureShipmentC1.feature_shipment_c1.getValue()
      ) && s.shipmentIsCod;

    return new ShipmentSttDetail({
      sttCommodityCode:
        f.commodity.code ||
        (!this.validationPrefix(["T1", "B1", "B2", "TKLP"]) ? "GEN" : ""),
      sttInsuranceType: f.protectionPacking.insuranceType,
      sttGoodsStatus: s.shipmentGoodsStatus,
      sttGoodsEstimatePrice: f.protectionPacking.itemPrice || 0,
      sttTaxNumber: s.shipmentNpwpNumber,
      sttIsWoodpacking: f.protectionPacking.woodpacking,
      sttIsCod:
        f.paymentMethod.method === PaymentMethodV4.COD ||
        f.paymentMethod.method === PaymentMethodV4.DFOD,
      sttIsDfod: f.paymentMethod.method === PaymentMethodV4.DFOD,
      sttCodAmount:
        f.paymentMethod.method === PaymentMethodV4.DFOD ||
        f.paymentMethod.method === PaymentMethodV4.CASH
          ? 0
          : f.paymentMethod.codAmount || f.protectionPacking.itemPrice || 0,
      sttCodFee: +s.codFee.toString().replace(/[.]/g, ""),
      sttPieces: f.pieces.map((piece: PieceBookingV4) => {
        const { width, length, height } = piece;

        return new PiecesApiRequest({
          sttPieceGrossWeight: parseFloat(
            Number(String(piece.grossWeight).replace(",", ".")).toFixed(3)
          ),
          sttPieceWidth: width,
          sttPieceLength: length,
          sttPieceHeight: height,
          sttPieceVolumeWeight: parseFloat(
            Number(piece.volumeWeight).toFixed(3)
          )
        });
      }),
      sttIsDo: s.isDO,
      isMixpack: false,
      sttShipmentId: s.shipmentAlgoId,
      sttPiecePerPack: Number(s.piecePerPack || 0),
      sttNextCommodity: s.nextCommodity,
      postalCodeDestination: postalCode,
      codHandling: shipmentC1Cod ? s.shipmentCodHandling : "",
      discountFavoritePercentage: this.validationPrefix(["AP", "AS"])
        ? s.discountFavoritePercentage
        : 0,
      sttRecipientAddressType: f.receiver.addressType.value,
      sttCiplAttachFiles: [
        f.supportingDoc.docInternational.imageBeforePackingUrl,
        f.supportingDoc.docInternational.imageAfterPackingUrl
      ].filter((img) => img),
      sttKtpImage: f.supportingDoc.docInternational.imageIdUrl,
      sttTaxImage: f.supportingDoc.docInternational.imageTaxUrl,
      sttRecipientEmail: f.supportingDoc.docInternational.email,
      sttIdentityNumber: f.supportingDoc.docInternational.idNumber,
      sttInterTaxNumber: f.supportingDoc.docInternational.taxNumber,
      sttCipl: this.docInternationalCommodityCipl
    });
  }

  get docInternationalCommodityCipl() {
    const list = this.bookingFormV4.commodityCipl || [];

    const hasAnyValue = list.some((cipl) => {
      const hasQuantity = !!Number(
        cipl.quantity.toString().replaceAll(".", "")
      );
      const hasPrice = !!Number(cipl.goodsPrice.toString().replaceAll(".", ""));
      const hasName = !!cipl?.name;

      return hasQuantity || hasPrice || hasName;
    });

    if (!hasAnyValue) return [];

    return list.map(
      (cipl) =>
        new SttCiplRequest({
          quantity: Number(cipl.quantity.toString().replaceAll(".", "")),
          itemPrice: Number(cipl.goodsPrice.toString().replaceAll(".", "")),
          itemDetailEn: cipl.name,
          itemDetail: cipl.name,
          commodityHsCode: cipl.hsCode
        })
    );
  }

  get payload(): AddShipmentBookingV2 {
    const { shipmentPacketId, shipmentGoodDetail } = this.shipmentDetail;
    const f = this.bookingFormV4;
    const destination = f.receiver.destinationCity;
    const normalizePhone = (phoneCode: string, phone: string): string => {
      const value = String(phone || "").replace(/^\+?0+/, "");
      const prefix = phoneCode || "+62";
      const normalizedPrefix = prefix.replace(/^\+/, "");
      const normalizedValue = value.replace(/^\+/, "");
      return normalizedValue.startsWith(normalizedPrefix)
        ? `+${normalizedValue}`
        : `+${normalizedPrefix}${normalizedValue}`;
    };

    const additionalDocUrls = this.bookingFormV4.supportingDoc.additionalDocuments.map(
      (item) => item.url
    );

    return new AddShipmentBookingV2({
      bookingFormVersion: "v4",
      shipmentPackageId: this.validationPrefix(["TKP"]) ? 0 : shipmentPacketId,
      goodsNames: [
        shipmentGoodDetail
          .map((item) => item["shipment_goods_name"])
          .filter(Boolean)
          .join(", ")
      ],
      sttWeightAttachFiles: f.adjustmentWeightAttachments.filter((key) => key),
      stt: new ShipmentSttDetail({
        ...this.shipmentSttDetailPayload,
        sttNoRefExternal: "",
        sttProductType: f.product.productType,
        sttOriginCityId: this.districtDetail.cityCode,
        sttOriginDistrictId: this.districtDetail.code,
        sttDestinationCityId:
          typeof destination === "string"
            ? destination
            : destination?.cityCode || "",
        sttDestinationDistrictId:
          typeof destination === "string"
            ? destination
            : destination?.code || "",
        sttSenderName: f.sender.name,
        sttSenderPhone: normalizePhone(f.sender.phoneCode, f.sender.phone),
        sttSenderAddress: f.sender.address,
        sttRecipientName: f.receiver.name,
        sttRecipientPhone: normalizePhone(
          f.receiver.phoneCode,
          f.receiver.phone
        ),
        sttRecipientAddress: f.receiver.address,
        sttAttachFiles: [
          f.supportingDoc.docInternational.imageIdUrl,
          f.supportingDoc.docInternational.imageTaxUrl
        ].filter((img) => img),
        sttCiplAttachFiles: [
          f.supportingDoc.docInternational.imageBeforePackingUrl,
          f.supportingDoc.docInternational.imageAfterPackingUrl,
          ...additionalDocUrls
        ].filter((img) => img),
        sttClientSttId: Number(f.sender.clientId)
      }),
      otherShipperTicketCode: this.shipmentDetail.dataRaw
        ?.other_shipper_ticket_code,
      sttClient: Number(f.sender.clientId)
    });
  }

  emitSubmit(): void {
    this.hasAttemptedSubmit = true;
    this.triggerAllFormErrors();

    if (!this.isAllSectionValid) {
      MainAppController.showErrorMessage(
        new ErrorMessageEntities({
          title: this.$t("bookingV4.validationError") as string,
          message: this.$t("bookingV4.completeForm") as string,
          type: CLIENT_ERROR,
          onTryAgain: () => {
            MainAppController.closeErrorMessage();
            const firstErrorSection = this.formCompletionItems.find(
              (item) => item.state === "error"
            );
            if (firstErrorSection) {
              this.onFormCompletionNavigate(firstErrorSection.key);
            }
          }
        })
      );
      return;
    }

    let newPayload: AddShipmentBookingV2 = new AddShipmentBookingV2();

    if (this.payload.stt.sttNoRefExternal.startsWith("TKP")) {
      const clientIdCourrierRecommendationConfig = FlagsMedusa.client_id_courrier_recommendation_config.getValue();
      newPayload = new AddShipmentBookingV2({
        ...this.payload,
        sttClient: Number(clientIdCourrierRecommendationConfig)
      });
    } else {
      newPayload = new AddShipmentBookingV2({
        ...this.payload,
        isCrossCountryCod: this.isCrossCountryCod,
        prefixCurrency: this.goodsPriceCurrencyPrefix
      });
    }

    const format = this.bookingFormV4.pageMeta.receiptFormat;
    const type =
      format === "a6"
        ? "book-print-thermal-pdf"
        : format === "a4"
        ? "book-print-pdf"
        : "book-print-later";

    const destination = this.bookingFormV4.receiver.destinationCity;
    const destinationCity =
      destination instanceof DistrictData
        ? new DistrictData(destination)
        : new DistrictData();

    const goodsDetail = newPayload.stt.sttPieces.map((item) => {
      return {
        shipment_goods_weight: item.sttPieceGrossWeight,
        shipment_goods_length: item.sttPieceLength,
        shipment_goods_width: item.sttPieceWidth,
        shipment_goods_height: item.sttPieceHeight
      };
    });

    const shipmentTable = new ShipmentIdTable({
      ...this.shipmentDetail,
      shipmentAlgoId: newPayload.stt.sttShipmentId,
      shipmentProduct: newPayload.stt.sttProductType,
      shipmentRecipientName: newPayload.stt.sttRecipientName,
      shipmentDestinationDistrict: destinationCity,
      shipmentGoodDetail: goodsDetail
    });

    this.$emit(
      "bookingShipment",
      newPayload,
      shipmentTable,
      type,
      this.isAddAddress
    );
  }

  get isAllSectionValid(): boolean {
    return (
      this.isSenderSectionValid &&
      this.isReceiverSectionValid &&
      this.isGoodsPiecesSectionValid &&
      !!this.bookingFormV4.product.productType &&
      !!this.bookingFormV4.paymentMethod.method &&
      (!this.showSupportingDocSection || this.isSupportingDocSectionValid) &&
      !!this.bookingFormV4.protectionPacking.itemPrice &&
      !String(this.errors.itemPrice).length
    );
  }

  get isLastShipment(): boolean {
    return Boolean(
      this.data.length && this.selectedIndex === this.data.length - 1
    );
  }

  onSkipShipment(): void {
    if (this.isLastShipment) {
      this.onCloseForm();
      this.$emit("skip", this.shipmentDetail);
      return;
    }
    this.$emit("skip", this.shipmentDetail);
  }

  shouldShowSectionValidationError(
    sectionKey: FormCompletionSectionKeyV4Value
  ): boolean {
    if (
      sectionKey === FormCompletionSectionKeyV4.REFERENCE_NUMBER &&
      !this.isReferenceRequired
    ) {
      return false;
    }

    const sectionMinIndex: Partial<Record<
      FormCompletionSectionKeyV4Value,
      number
    >> = {
      [FormCompletionSectionKeyV4.SENDER]: 1,
      [FormCompletionSectionKeyV4.RECEIVER]: 5,
      [FormCompletionSectionKeyV4.REFERENCE_NUMBER]: 9,
      [FormCompletionSectionKeyV4.GOODS_PIECES]: 11,
      [FormCompletionSectionKeyV4.SUPPORTING_DOCUMENTS]: 20
    };

    const minIndex = sectionMinIndex[sectionKey];
    const isBypassed =
      minIndex !== undefined &&
      this.currentIndex !== -1 &&
      this.currentIndex > minIndex + 3;

    const shouldEvaluate = this.hasAttemptedSubmit || isBypassed;
    if (!shouldEvaluate) return false;

    switch (sectionKey) {
      case FormCompletionSectionKeyV4.SENDER:
        return !this.isSenderSectionValid;
      case FormCompletionSectionKeyV4.RECEIVER:
        return !this.isReceiverSectionValid;
      case FormCompletionSectionKeyV4.REFERENCE_NUMBER:
        return this.isReferenceRequired && !this.isReferenceSectionValid;
      case FormCompletionSectionKeyV4.GOODS_PIECES:
        return !this.isGoodsPiecesSectionValid;
      case FormCompletionSectionKeyV4.SUPPORTING_DOCUMENTS:
        return (
          this.showSupportingDocSection && !this.isSupportingDocSectionValid
        );
      case FormCompletionSectionKeyV4.PRODUCT_TYPE:
        return !this.bookingFormV4.product.productType;
      default:
        return false;
    }
  }

  resolveSectionCompletionState(
    sectionKey: FormCompletionSectionKeyV4Value,
    isValid: boolean
  ): string {
    if (isValid) return FormCompletionSectionStateV4.COMPLETE;
    return this.shouldShowSectionValidationError(sectionKey)
      ? "error"
      : FormCompletionSectionStateV4.INCOMPLETE;
  }

  get supportingDocCompletionFields(): FormCompletionFieldRowV4[] {
    return SUPPORTING_DOC_COMPLETION_FIELD_ORDER.filter(
      (fieldKey) =>
        !!this.supportingDocFieldRules[fieldKey] &&
        this.supportingDocFieldRules?.[fieldKey]?.isRequired
    ).map((fieldKey) => {
      const rule = this.supportingDocFieldRules[fieldKey] as SttAdjustmentRule;
      return new FormCompletionFieldRowV4({
        fieldKey,
        fieldLabel: this.$t(
          SUPPORTING_DOC_FIELD_LABEL_I18N[fieldKey]
        ) as string,
        status: rule.isRequired ? "wajib" : "opsional"
      });
    });
  }

  get formCompletionItems(): FormCompletionPanelItemV4[] {
    const items: FormCompletionPanelItemV4[] = [
      new FormCompletionSectionBookingV4({
        key: FormCompletionSectionKeyV4.SENDER,
        label: this.$t("bookingV4.formCompletion.sender") as string,
        state: this.resolveSectionCompletionState(
          FormCompletionSectionKeyV4.SENDER,
          this.isSenderSectionValid
        )
      }),
      new FormCompletionSectionBookingV4({
        key: FormCompletionSectionKeyV4.RECEIVER,
        label: this.$t("bookingV4.formCompletion.recipient") as string,
        state: this.resolveSectionCompletionState(
          FormCompletionSectionKeyV4.RECEIVER,
          this.isReceiverSectionValid
        )
      })
    ];

    if (this.isReferenceRequired) {
      items.push(
        new FormCompletionSectionBookingV4({
          key: FormCompletionSectionKeyV4.REFERENCE_NUMBER,
          label: this.$t("bookingV4.formCompletion.referenceNumber") as string,
          state: this.resolveSectionCompletionState(
            FormCompletionSectionKeyV4.REFERENCE_NUMBER,
            this.isReferenceSectionValid
          )
        })
      );
    }

    items.push(
      new FormCompletionSectionBookingV4({
        key: FormCompletionSectionKeyV4.GOODS_PIECES,
        label: this.$t("bookingV4.formCompletion.goods") as string,
        state: this.resolveSectionCompletionState(
          FormCompletionSectionKeyV4.GOODS_PIECES,
          this.isGoodsPiecesSectionValid
        )
      })
    );

    if (this.showSupportingDocSection) {
      const supportingDocumentsItem: FormCompletionPanelItemV4 = new FormCompletionSectionBookingV4(
        {
          key: FormCompletionSectionKeyV4.SUPPORTING_DOCUMENTS,
          label: this.$t("bookingV4.formCompletion.doc") as string,
          state: this.resolveSectionCompletionState(
            FormCompletionSectionKeyV4.SUPPORTING_DOCUMENTS,
            this.isSupportingDocSectionValid
          )
        }
      );
      supportingDocumentsItem.fields = this.supportingDocCompletionFields;
      items.push(supportingDocumentsItem);
    }

    return items;
  }

  onFormCompletionNavigate(sectionKey: FormCompletionSectionKeyV4Value): void {
    const anchorId = FORM_COMPLETION_SECTION_ANCHORS[sectionKey];
    document.getElementById(anchorId)?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    });
  }

  get isAccountForeignPos(): boolean {
    return !this.accountIsNonForeign;
  }

  get formLocalCurrencyCode(): string {
    return getCurrencyByCountryCode(
      this.bookingFormV4.receiver.destinationCountryCode
    );
  }

  get goodsPriceCurrencyPrefix(): string {
    if (this.isCrossCountryCod) {
      return (
        this.bookingFormV4.receiver.destinationCountry.currencySymbol || "-"
      );
    }

    return this.formCurrencyPrefix;
  }

  get formCurrencyPrefix(): string {
    return configPrice[this.formAccountCurrencyCode]?.prefix ?? "Rp";
  }

  get formAccountCurrencyCode(): string {
    return getCurrencyByCountryCode(this.accountCountryCode);
  }

  get formAccountCurrencyPrefix(): string {
    return configPrice[this.formAccountCurrencyCode]?.prefix ?? "Rp";
  }

  get formAccountNumericLocale(): string {
    return configPrice[this.formAccountCurrencyCode]?.locales ?? "id";
  }

  get formNumericLocale(): string {
    return configPrice[this.formAccountCurrencyCode]?.locales ?? "id";
  }

  get isDestinationForeign(): boolean {
    return isMalaysiaDistrict(
      this.bookingFormV4.receiver.destinationCountryCode
    );
  }

  get isPosAccount(): boolean {
    return AccountController.accountData.isPosAccount;
  }

  get isNonClientAccount(): boolean {
    return (
      AccountController.accountData.isAllPartner ||
      AccountController.accountData.isInternalAccount
    );
  }

  get isForeignAccount(): boolean {
    return AccountController.accountData.accountIsForeign;
  }

  get isEligibleDestinationCOD(): boolean {
    if (!this.destinationCityDetail?.id) return true;
    return this.destinationCityDetail.isCod === "yes";
  }

  get isEligiblePartnerCOD(): boolean {
    if (this.isForeignAccount) return false;
    if (!this.isPosAccount) return true;
    return AccountController.accountData.account_type_detail
      .partnerIsCodBooking;
  }

  get isEligibleClientCOD(): boolean {
    if (this.isPosAccount) return true;
    if (this.isNonClientAccount) return true;
    return AccountController.accountData.account_type_detail.isCod;
  }

  get isEligibleClientDFOD(): boolean {
    if (this.isPosAccount) return true;
    if (this.isNonClientAccount) return true;
    return AccountController.accountData.account_type_detail.isDfod;
  }

  get isPhoneNumberBlacklist(): boolean {
    return BookingController.phoneCheckerData.isBlacklist;
  }

  get isPhoneNumberLimit(): boolean {
    return (
      BookingController.phoneCheckerData.status === FraudStatus.LIMITED &&
      FlagsPermissionBooking.disable_cod_dfod_for_limited_number.isEnabled()
    );
  }

  get disabledCODMessage(): string {
    if (this.isPhoneNumberBlacklist) {
      return this.$t("bookingV4.payment.disable.blacklist") as string;
    }
    if (this.isPhoneNumberLimit) {
      return this.$t("bookingV4.payment.disable.dailyLimit") as string;
    }
    if (!this.isEligiblePartnerCOD) {
      return this.$t("bookingV4.payment.disable.partner") as string;
    }
    if (!this.isEligibleClientCOD) {
      return this.$t("bookingV4.payment.disable.client") as string;
    }
    if (!this.isEligibleDestinationCOD) {
      return this.$t("bookingV4.payment.disable.destination") as string;
    }
    return this.$t("bookingV4.payment.disable.generic") as string;
  }

  get disabledDFODMessage(): string {
    if (!this.isEligibleClientDFOD) {
      return this.$t("bookingV4.payment.disable.client") as string;
    }
    return this.disabledCODMessage;
  }

  get isPhoneNumberFraud(): boolean {
    return [this.isPhoneNumberLimit, this.isPhoneNumberBlacklist].some(Boolean);
  }

  // AP/AS shipment only: retail COD/DFOD gating by route country.
  // - origin non-ID (any non-ID origin) cannot use COD/DFOD
  // - origin ID to a non-ID destination cannot use COD/DFOD
  // Only applies once a destination is selected; empty destination keeps COD enabled.
  // Scoped to AP/AS (isShipmentFavorite) per requirement — other shipment
  // types keep their existing payment-method handling untouched.
  get isApAsRouteCodDisabled(): boolean {
    if (!this.isShipmentFavorite) return false;
    if (!this.destinationCityDetail?.id) return false;
    const originCode = (this.originCountry || "").trim().toUpperCase();
    const destCode = (this.destinationCityDetail.countryCode || "")
      .trim()
      .toUpperCase();
    if (!originCode || !destCode) return false;
    if (originCode !== "ID") return true;
    return destCode !== "ID";
  }

  get paymentEligibility(): PaymentEligibilityV4 {
    return {
      cod: {
        disabled: [
          !this.isEligibleDestinationCOD,
          !this.isEligiblePartnerCOD,
          !this.isEligibleClientCOD,
          this.isPhoneNumberFraud,
          this.isApAsRouteCodDisabled
        ].some(Boolean),
        hoverCopy: this.disabledCODMessage
      },
      dfod: {
        disabled: [
          !this.isEligibleClientDFOD,
          !this.isEligibleDestinationCOD,
          !this.isEligiblePartnerCOD,
          this.isPhoneNumberFraud,
          this.isApAsRouteCodDisabled
        ].some(Boolean),
        hoverCopy: this.disabledDFODMessage
      },
      // posLimit: {
      //   disabled: InvoiceLimitController.invoiceLimitStatusSummary.isFrozen,
      //   remainingLimit:
      //   InvoiceLimitController.invoiceLimitStatusSummary.remainingLimit
      // }
    };
  }

  disabledPaymentMethod(method: string) {
    return (
      this.configRule.serviceType.rule === ConfigValidationForm.NON_EDITABLE &&
      method !== this.bookingFormV4.paymentMethod.method
    );
  }

  get isPaymentCash() {
    return this.bookingFormV4.paymentMethod.method === PaymentMethodV4.CASH;
  }

  get isPaymentCOD() {
    return this.bookingFormV4.paymentMethod.method === PaymentMethodV4.COD;
  }

  get isPaymentDFOD() {
    return this.bookingFormV4.paymentMethod.method === PaymentMethodV4.DFOD;
  }

  get isPaymentPosLimit() {
    return (
      this.bookingFormV4.paymentMethod.method === PaymentMethodV4.INVOICE_LIMIT
    );
  }

  mapPaymentMethodOptions(
    eligibility: PaymentEligibilityV4
  ): PaymentMethodOptionV4[] {
    const options: PaymentMethodOptionV4[] = [
      new PaymentMethodOptionV4({
        key: PaymentMethodV4.CASH,
        disabled: this.disabledPaymentMethod(PaymentMethodV4.CASH)
      })
    ];

    options.push(
      new PaymentMethodOptionV4({
        key: PaymentMethodV4.COD,
        disabled:
          eligibility.cod.disabled ||
          this.disabledPaymentMethod(PaymentMethodV4.COD),
        hoverCopy: eligibility.cod.disabled ? eligibility.cod.hoverCopy : ""
      }),
      new PaymentMethodOptionV4({
        key: PaymentMethodV4.DFOD,
        disabled:
          eligibility.dfod.disabled ||
          this.disabledPaymentMethod(PaymentMethodV4.DFOD),
        hoverCopy: eligibility.dfod.disabled ? eligibility.dfod.hoverCopy : ""
      })
    );

    // const eligiblePosLimit =
    //   this.accountIsNonForeign &&
    //     InvoiceLimitController.invoiceLimitStatusSummary.status === "active";

    // if (eligiblePosLimit) {
    //   options.push(
    //     new PaymentMethodOptionV4({
    //       key: PaymentMethodV4.INVOICE_LIMIT,
    //       disabled: eligibility.posLimit.disabled,
    //       hoverCopy: eligibility.posLimit.disabled
    //         ? (this.$t("bookingV4.payment.disable.invoiceLimitFrozen") as string)
    //         : "",
    //       remainingLimit: eligibility.posLimit.remainingLimit
    //     })
    //   );
    // }

    return options;
  }

  get paymentMethodOptions(): PaymentMethodOptionV4[] {
    return this.mapPaymentMethodOptions(this.paymentEligibility);
  }

  onPaymentMethodUpdate(payload: PaymentMethodBookingV4): void {
    this.bookingFormV4.paymentMethod = payload;
    this.syncFavoriteCodAmount();
    this.validateErrorPrice();
  }

  syncFavoriteCodAmount(): void {
    if (!this.isShipmentFavorite || !this.isPaymentCOD) return;
    this.bookingFormV4.paymentMethod.codAmount = this.bookingFormV4.protectionPacking.itemPrice;
  }

  get codAmountConfig(): SttAdjustmentRule {
    return this.isShipmentFavorite
      ? this.mapSttAdjustmentRule(false)
      : this.configRule.codAmount;
  }

  async getCODConfig(): Promise<void> {
    try {
      const res = await CodConfigurationController.getList(
        new ApiRequestList({
          page: 1,
          limit: 20,
          status: "active"
        })
      );

      const ccoNameByPrefix = this.validationPrefix(["T"])
        ? "COD TOKOPEDIA MP"
        : this.isCAPrefix
        ? "COD CA RETAIL"
        : "";
      const ccoDFODNameByPrefix = this.isCAPrefix ? "DFOD CA" : "";
      const codConfig = res.data.find(
        (config: DetailCodConfigurationRetail) => {
          return config.ccoName === ccoNameByPrefix;
        }
      ) as DetailCodConfigurationRetail;
      const dfodConfig = res.data.find(
        (config: DetailCodConfigurationRetail) => {
          return config.ccoName === ccoDFODNameByPrefix;
        }
      ) as DetailCodConfigurationRetail;

      const configCodInternationalClient = new DetailCodConfigurationRetail(
        res.data.find(
          (config: DetailCodConfigurationRetail) =>
            config.ccoName === "COD International Client"
        )
      );

      this.ccoCodActive = new DetailCodConfigurationRetail(codConfig);
      this.ccoDfodActive = new DetailCodConfigurationRetail(dfodConfig);
      this.configCodInternationalClient = configCodInternationalClient;
      this.initAdjustmentStt();
    } catch {
      // ignore
    }
  }

  get isCodInsuranceActive(): boolean {
    const method = this.bookingFormV4.paymentMethod.method;
    return this.ccoCodActive.ccoIsInsurance && method === PaymentMethodV4.COD;
  }

  get isDfodInsuranceActive(): boolean {
    const method = this.bookingFormV4.paymentMethod.method;
    return this.ccoDfodActive.ccoIsInsurance && method === PaymentMethodV4.DFOD;
  }

  get isCodDfodInsuranceActive() {
    return this.isCodInsuranceActive || this.isDfodInsuranceActive;
  }

  get originCountry(): string {
    return (
      this.districtDetail?.countryCode ??
      AccountController.accountData.countryCode
    );
  }

  getInsuranceAvailability = debounce(async () => {
    if (!getToken()) return;
    await BookingController.getInsuranceTypesDelivery({
      insuranceConfig: 2,
      originCountry: this.originCountry
    });
  }, 500);

  get insuranceBasic(): InsuranceTypeDeliveryData {
    const basic = BookingController.insuranceTypeDelivery.data.find(
      (item: InsuranceTypeDeliveryData) => item.value === "basic"
    );

    return new InsuranceTypeDeliveryData(basic);
  }

  // Config-driven (not MY-hardcoded): configurable whenever backend exposes an
  // available basic insurance with a start-from threshold.
  get isAvailableInsurance(): boolean {
    return (
      this.insuranceBasic.isAvailable &&
      this.insuranceBasic.insuranceBasicStartFrom > 0
    );
  }

  get isProtectionThresholdDisabled(): boolean {
    const itemPrice = this.bookingFormV4.protectionPacking.itemPrice || 0;
    return (
      this.isAvailableInsurance &&
      itemPrice <= this.insuranceBasic.insuranceBasicStartFrom
    );
  }

  get validationGreather5Million(): boolean {
    if (this.accountCountryCode.toUpperCase() !== "ID") return false;
    const itemPrice = this.bookingFormV4.protectionPacking.itemPrice || 0;
    return itemPrice >= 5000000;
  }

  get insurancePayload(): ApiRequestList {
    return new ApiRequestList({
      isPagination: true,
      typeInsurance: this.bookingFormV4.protectionPacking.insuranceType,
      goodsPrice: this.bookingFormV4.protectionPacking.itemPrice,
      country: AccountController.accountData.countryCode,
      accountType: this.isTokopediaPrefix ? "client" : "pos",
      accountRefId: this.isTokopediaPrefix
        ? 2095
        : AccountController.accountData.account_type_detail?.id
    });
  }

  getInsuranceConfig = debounce(async () => {
    if (
      !this.bookingFormV4.protectionPacking.itemPrice &&
      this.accountCountryCode.toUpperCase() !== "ID"
    )
      return;
    const resp = await InsuranceController.getInsurance(this.insurancePayload);
    this.insuranceData = resp;
  }, 500);

  get posInsuranceCommissionAmount(): number {
    return this.insuranceData.commisionPos;
  }

  get agentDiscountCommission(): string | undefined {
    if (
      !this.isPosAccount ||
      this.isCodDfodInsuranceActive ||
      !this.insuranceBasic.isAvailable ||
      this.isProtectionThresholdDisabled
    ) {
      return undefined;
    }
    const amount = this.posInsuranceCommissionAmount;
    return this.accountIsNonForeign
      ? formatPriceRP(amount)
      : formatPriceRM(amount);
  }

  get totalGrossWeightKg(): number {
    return this.bookingFormV4.pieces.reduce(
      (sum, piece) => sum + (piece.grossWeight || 0),
      0
    );
  }

  get totalVolumeWeightKg(): number {
    return this.bookingFormV4.pieces.reduce(
      (sum, piece) => sum + Math.trunc((piece.volumeWeight || 0) * 100) / 100,
      0
    );
  }

  get woodpackingEligibilitySignature(): string {
    return [
      this.districtDetail?.cityCode,
      this.bookingFormV4.product?.productType,
      this.bookingFormV4.receiver?.id
    ].join("|");
  }

  // get woodpackingEligibility(): WoodpackingEligibility {
  //   return BookingController.woodpackingEligibility;
  // }

  get isWoodpackingConfigActive(): boolean {
    return Boolean(this.bookingFormV4.protectionPacking.woodpackingEligible);
  }

  get computedWoodpackingEligible(): boolean {
    return (
      this.isWoodpackingConfigActive && !!this.bookingFormV4.product.productType
    );
  }

  // get woodpackingAdditionalWeightKgPreview(): number {
  //   if (!this.computedWoodpackingEligible) return 0;
  //   const base = Math.max(this.totalGrossWeightKg, this.totalVolumeWeightKg);
  //   if (!base) return 0;

  //   const { cwPercent, minCwKg } = this.woodpackingEligibility || {};

  //   const percentageWeight = base * ((cwPercent || 0) / 100);
  //   const minWeight = minCwKg || 0;

  //   const result = Math.max(percentageWeight, minWeight);
  //   return Math.ceil(result * 100) / 100;
  // }

  get piecesWeightSignature(): string {
    return this.bookingFormV4.pieces
      .map((piece) => `${piece.grossWeight}:${piece.volumeWeight}`)
      .join(",");
  }

  get protectionDeriveSignature(): string {
    return [
      this.bookingFormV4.protectionPacking.itemPrice,
      this.bookingFormV4.protectionPacking.insuranceType,
      this.bookingFormV4.paymentMethod.method,
      this.bookingFormV4.product.productType,
      this.bookingFormV4.receiver.destinationCountryCode,
      this.piecesWeightSignature
    ].join("|");
  }

  // fetchWoodpackingEligibilityDebounced = debounce(async function(this: any) {
  //   const origin3lc = this.districtDetail.cityCode;
  //   const productType = this.bookingFormV4.product?.productType;
  //   const accountRef = this.bookingFormV4.receiver?.id;

  //   const isInvalid = !origin3lc || !productType;

  //   if (isInvalid) {
  //     this.bookingFormV4.protectionPacking.woodpackingEligible = false;
  //     this.onSetWoodpacking();
  //     return;
  //   }

  //   try {
  //     const response = await BookingController.getWoodpackingEligibility(
  //       new WoodpackingEligibilityQuery({
  //         origin3lc: origin3lc,
  //         productType: productType.toUpperCase().trim(),
  //         accountRef: accountRef
  //       })
  //     );

  //     this.bookingFormV4.protectionPacking.woodpackingEligible = response
  //       ? response.eligible
  //       : false;
  //   } catch (error) {
  //     this.bookingFormV4.protectionPacking.woodpackingEligible = false;
  //   } finally {
  //     this.onSetWoodpacking();
  //   }
  // }, 300);

  onSetWoodpacking() {
    const pp = this.bookingFormV4.protectionPacking;
    const eligible = this.computedWoodpackingEligible;
    pp.woodpackingEligible = eligible;
    if (!eligible && pp.woodpacking) {
      pp.woodpacking = false;
    }
    // pp.woodpackingAdditionalWeightKg = this.woodpackingAdditionalWeightKgPreview;

    pp.totalKoli = this.bookingFormV4.pieces.length;
    pp.chargeableWeightKg = this.chargeableWeightBreakdown.finalCwKg;
  }

  onSetInsurance(): void {
    const pp = this.bookingFormV4.protectionPacking;
    const greather5Million = this.validationGreather5Million;

    const changed = pp.hasChanged;
    const lastChecked = pp.lastChecked;
    const checked = changed
      ? lastChecked
      : this.shipmentInsuranceType === "basic";

    if (this.isPaymentCash) {
      if (greather5Million) {
        pp.protectionDisabled = true;
        pp.protectionChecked = true;
        pp.insuranceType = "basic";
        return;
      }

      pp.protectionChecked = checked;
      pp.insuranceType = checked ? "basic" : "free";
      pp.protectionDisabled = false;
      pp.showTresholdProtection = false;
      pp.protectionLabel = "";
      return;
    }

    if (this.isPaymentCOD) {
      const configActive = this.isCodInsuranceActive;

      if (greather5Million && !configActive) {
        pp.protectionDisabled = true;
        pp.protectionChecked = true;
        pp.insuranceType = "basic";
        pp.protectionLabel = "";
        return;
      }

      // SHIPMENT: TOKOPEDIA | CA (except: AP, AS)
      if (this.isTokopediaPrefix || this.isCaSpecificPrefix) {
        if (configActive) {
          pp.protectionLabel = this.$t(
            "bookingV4.protection.alreadyProtected"
          ) as string;
          pp.protectionDisabled = true;
          pp.protectionChecked = false;
          pp.insuranceType = "free";
          return;
        }

        pp.protectionDisabled = true;
        pp.protectionChecked = checked;
        pp.insuranceType = checked ? "basic" : "free";
        pp.protectionLabel = "";
        return;
      }

      // SHIPMENT: FAVORITE (AP, AS)
      if (this.isShipmentFavorite) {
        if (configActive) {
          pp.protectionLabel = this.$t(
            "bookingV4.protection.alreadyProtected"
          ) as string;
          pp.protectionDisabled = true;
          pp.protectionChecked = false;
          pp.insuranceType = "free";
          return;
        }

        const checked = pp.protectionChecked;
        pp.protectionDisabled = false;
        pp.protectionChecked = checked;
        pp.insuranceType = checked ? "basic" : "free";
        pp.protectionLabel = "";
        return;
      }

      if (configActive) {
        pp.protectionLabel = this.$t(
          "bookingV4.protection.alreadyProtected"
        ) as string;
        pp.protectionDisabled = true;
        pp.protectionChecked = false;
        pp.insuranceType = "free";
        return;
      }

      if (pp.changeType === "woodpacking") return;

      pp.protectionChecked = checked;
      pp.insuranceType = checked ? "basic" : "free";
      pp.protectionDisabled = false;
      pp.protectionLabel = "";
      return;
    }

    if (this.isPaymentDFOD) {
      const configActive = this.isDfodInsuranceActive;

      if (greather5Million && !configActive) {
        pp.protectionDisabled = true;
        pp.protectionChecked = true;
        pp.insuranceType = "basic";
        pp.protectionLabel = "";
        return;
      }

      // SHIPMENT: TOKOPEDIA | CA (except: AP, AS)
      if (this.isTokopediaPrefix || this.isCaSpecificPrefix) {
        if (configActive) {
          pp.protectionLabel = this.$t(
            "bookingV4.protection.alreadyProtected"
          ) as string;
          pp.protectionDisabled = true;
          pp.protectionChecked = false;
          pp.insuranceType = "free";
          return;
        }

        pp.protectionDisabled = true;
        pp.protectionChecked = checked;
        pp.insuranceType = checked ? "basic" : "free";
        pp.protectionLabel = "";
        return;
      }

      // SHIPMENT: FAVORITE (AP, AS)
      if (this.isShipmentFavorite) {
        if (configActive) {
          pp.protectionLabel = this.$t(
            "bookingV4.protection.alreadyProtected"
          ) as string;
          pp.protectionDisabled = true;
          pp.protectionChecked = false;
          pp.insuranceType = "free";
          return;
        }

        pp.protectionDisabled = false;
        pp.protectionChecked = checked;
        pp.insuranceType = checked ? "basic" : "free";
        pp.protectionLabel = "";
        return;
      }

      if (configActive) {
        pp.protectionLabel = this.$t(
          "bookingV4.protection.alreadyProtected"
        ) as string;
        pp.protectionDisabled = true;
        pp.protectionChecked = false;
        pp.insuranceType = "free";
        return;
      }

      pp.protectionChecked = checked;
      pp.insuranceType = checked ? "basic" : "free";
      pp.protectionDisabled = false;
      pp.protectionLabel = "";
      return;
    }
  }

  get chargeableWeightBreakdown(): ChargeableWeightBreakdownV4 {
    const pp = this.bookingFormV4.protectionPacking;
    const totalWpWeightKg = pp.woodpacking
      ? pp.woodpackingAdditionalWeightKg
      : 0;
    const chWeight =
      Math.max(this.totalGrossWeightKg, this.totalVolumeWeightKg) +
      totalWpWeightKg;
    const selectedProduct = this.bookingFormV4.product.productType;
    const currentRule = this.configurationRules.find(
      (rule) => rule.product?.toLowerCase() === selectedProduct.toLowerCase()
    );

    if (!selectedProduct) {
      const finalCwKg = getRoundedChargeableWeightByRules({
        chargeableWeight: chWeight,
        productType: "",
        rule: 0.31
      });
      return new ChargeableWeightBreakdownV4({
        totalGrossWeightKg: this.totalGrossWeightKg,
        totalVolumeWeightKg: this.totalVolumeWeightKg,
        totalWpWeightKg,
        finalCwKg
      });
    }

    const isEligible = isEligibleForMaxVolumeWeightDiscount({
      productType: selectedProduct,
      volumeWeight: this.totalVolumeWeightKg
    });
    const baseWeight =
      isEligible || selectedProduct.toUpperCase() === "INTERPACKMAXI"
        ? this.totalGrossWeightKg
        : Math.max(this.totalGrossWeightKg, this.totalVolumeWeightKg);

    const finalCwKg = getRoundedChargeableWeightByRules({
      chargeableWeight: baseWeight + totalWpWeightKg,
      productType: selectedProduct.toUpperCase(),
      rule: Number(currentRule?.parameter) || 0.31,
      ruleKey: currentRule?.ruleKey
    });

    return new ChargeableWeightBreakdownV4({
      totalGrossWeightKg: this.totalGrossWeightKg,
      totalVolumeWeightKg: this.totalVolumeWeightKg,
      totalWpWeightKg,
      finalCwKg
    });
  }

  mapErrorCodDfod(value: number): string {
    if (this.isCrossCountryCod) {
      const formatted = formatByCountry(value, {
        type: "weight",
        country: this.bookingFormV4.receiver.destinationCountry.code,
        fractionDigits: 6,
        minFractionDigits: 0
      });

      return `${this.bookingFormV4.receiver.destinationCountry.currencySymbol}${formatted}`;
    }

    return this.accountIsNonForeign
      ? formatPriceRP(value)
      : formatPriceRM(value);
  }

  get isShipmentCA(): boolean {
    return isShipmentCa(this.bookingFormV4.shipmentId);
  }

  get minMaxType() {
    const type = this.isShipmentCA
      ? "shipment_ca"
      : this.validationPrefix([
          "T1",
          "TKLP",
          "TKP",
          "TSLP",
          "C1",
          "C2",
          "B1",
          "B2"
        ])
      ? "shipment_corporate"
      : "retail";
    return type;
  }

  get minMaxConfig() {
    return getMinMaxGoodsPriceFromFlag(this.minMaxType);
  }

  validateErrorPrice(): void {
    if (
      this.bookingFormV4.paymentMethod.method === PaymentMethodV4.COD ||
      this.bookingFormV4.paymentMethod.method === PaymentMethodV4.DFOD
    ) {
      const ccoConfig =
        this.bookingFormV4.paymentMethod.method === PaymentMethodV4.DFOD
          ? this.ccoDfodActive
          : this.ccoCodActive;

      const itemPrice = this.bookingFormV4.protectionPacking.itemPrice || 0;

      let min = 0;
      let max = 0;

      if (this.isCrossCountryCod) {
        const { minPrice, maxPrice } = this.codConfigByDestination;

        min = Number(minPrice);
        max = Number(maxPrice);
      } else if (ccoConfig.ccoId) {
        const { ccoMinPrice, ccoMaxPrice } = ccoConfig;
        min = ccoMinPrice;
        max = ccoMaxPrice;
      } else {
        const { min: minPrice, max: maxPrice } = this.minMaxConfig;

        min = minPrice;
        max = maxPrice;
      }

      const isBelowMin = itemPrice < min;
      const isAboveMax = itemPrice > max;

      this.errors.itemPrice = isBelowMin
        ? (this.$t("bookingV4.protection.itemPrice.errorMin", {
            value: this.mapErrorCodDfod(min)
          }) as string)
        : isAboveMax
        ? (this.$t("bookingV4.protection.itemPrice.errorMax", {
            value: this.mapErrorCodDfod(max)
          }) as string)
        : "";
      return;
    }

    const itemPrice = this.bookingFormV4.protectionPacking.itemPrice || 0;

    if (itemPrice === null || itemPrice <= 0) {
      this.errors.itemPrice = this.$t("bookingV4.protection.itemPrice.error");
      return;
    }

    const { min, max } = this.minMaxConfig;
    const isBelowMin = itemPrice < min;
    const isAboveMax = itemPrice > max;
    this.errors.itemPrice = isBelowMin
      ? this.$t("bookingV4.protection.itemPrice.errorMin", {
          value: this.mapErrorCodDfod(min)
        })
      : isAboveMax
      ? this.$t("bookingV4.protection.itemPrice.errorMax", {
          value: this.mapErrorCodDfod(max)
        })
      : "";
  }

  onProtectionPackingUpdate(value: ProtectionPackingBookingV4): void {
    this.bookingFormV4.protectionPacking = value;
    this.syncFavoriteCodAmount();
    this.onSetInsurance();
    this.validateErrorPrice();
  }

  onItemPriceBlur(): void {
    this.validateErrorPrice();
  }

  onProtectionPackingUpdateFromCwFooter(
    value: ProtectionPackingBookingV4
  ): void {
    this.bookingFormV4.protectionPacking.chargeableWeightExpanded =
      value.chargeableWeightExpanded;
  }

  get productUpsellingContextSignature(): string {
    return JSON.stringify(this.upsellingPayload);
  }

  get upsellingPayload(): PayloadPosterProduct {
    const destination = this.destinationCityDetail;
    const protectionPacking = this.bookingFormV4.protectionPacking;
    const paymentMethod = this.bookingFormV4.paymentMethod;
    const goodsPrice = protectionPacking.itemPrice || 0;
    const isCodOrDfod = [
      PaymentMethodV4.COD.toString(),
      PaymentMethodV4.DFOD.toString()
    ].includes(paymentMethod.method);
    const codAmount = Math.max(
      isCodOrDfod ? 1 : 0,
      paymentMethod.codAmount || goodsPrice
    );
    return new PayloadPosterProduct({
      originId: this.districtDetail.code,
      destinationId: destination?.code || "",
      accountType: "client",
      accountRefId: this.accountRefId,
      commodityId: this.bookingFormV4.commodity.id || 499,
      productType: "",
      goodsPrice: goodsPrice,
      codAmount: codAmount,
      isCod: isCodOrDfod,
      isDfod: this.bookingFormV4.paymentMethod.method === PaymentMethodV4.DFOD,
      isPad: false,
      insuranceType: this.bookingFormV4.protectionPacking.insuranceType,
      isWoodpacking: this.bookingFormV4.protectionPacking.woodpacking,
      isHaveTaxId: !!this.bookingFormV4.supportingDoc.ftzForm.taxNumber,
      pieces: this.bookingFormV4.pieces.map((piece) => ({
        pieceLength: piece.length || (this.isCipl ? 3 : 0),
        pieceWidth: piece.width || (this.isCipl ? 20 : 0),
        pieceHeight: piece.height || (this.isCipl ? 10 : 0),
        pieceGrossWeight: piece.grossWeight
      })),
      promoAppliedTo: "shipment",
      isDisablePromo: false,
      shipmentPrefix: this.bookingFormV4.shipmentId?.slice(0, 2),
      isBookingPuposes: false
    });
  }

  fetchProductUpsellingDebounced = debounce(() => {
    this.fetchProductUpselling();
  }, 500);

  get normalizedSenderPhone(): string {
    const sender = this.bookingFormV4.sender;
    return `${sender.phone ? sender.phoneCode : ""}${sender.phone}`.replace(
      /\+/g,
      ""
    );
  }

  estimationShipmentPrefix(shipmentId: string) {
    const prefixList = ["AP", "AS", "ARA", "ARB", "AD", "AG"];
    const findPrefix = prefixList.find((item: string) =>
      shipmentId.toUpperCase()?.startsWith(item)
    );
    return findPrefix ?? "";
  }

  get estimationPriceContextPayload(): GetEstimationPriceV4 {
    const protectionPacking = this.bookingFormV4.protectionPacking;
    const paymentMethod = this.bookingFormV4.paymentMethod;
    const goodsPrice = protectionPacking.itemPrice || 0;
    const isCodOrDfod = [
      PaymentMethodV4.COD.toString(),
      PaymentMethodV4.DFOD.toString()
    ].includes(paymentMethod.method);
    const codAmount = Math.max(
      isCodOrDfod ? 1 : 0,
      paymentMethod.codAmount || goodsPrice
    );
    return new GetEstimationPriceV4({
      originId: this.districtDetail.code,
      destinationId: this.destinationCityDetail?.code || "",
      commodityId: this.bookingFormV4.commodity.id,
      productType: this.bookingFormV4.product.productType,
      accountType: "client",
      accountRefId: this.accountRefId,
      goodsPrice,
      insuranceType: protectionPacking.insuranceType,
      isWoodpacking: protectionPacking.woodpacking,
      isHaveTaxId:
        this.isFtzForm && !!this.bookingFormV4.supportingDoc.ftzForm.taxNumber,
      pieces: this.bookingFormV4.pieces.map((piece) => ({
        pieceLength: piece.length,
        pieceWidth: piece.width,
        pieceHeight: piece.height,
        pieceGrossWeight: piece.grossWeight
      })) as any,
      isCod: isCodOrDfod,
      isDfod: paymentMethod.method === PaymentMethodV4.DFOD,
      codHandling: "",
      codAmount: codAmount || 0,
      isDisablePromo:
        this.isTokopediaPrefix || this.isCorporatePrefix || this.isB1B2,
      promoAppliedTo: "shipment",
      isPad: false,
      shipmentPrefix: this.estimationShipmentPrefix(
        this.bookingFormV4.shipmentId
      ),
      hideError: false,
      senderPhone: this.normalizedSenderPhone
    });
  }

  get accountRefId() {
    return this.isTokopediaPrefix
      ? 2095
      : this.isCorporatePrefix
      ? this.clientIdBranch
      : 2311;
  }

  get isTariffContextReady(): boolean {
    const hasCompletePieces =
      this.bookingFormV4.pieces.length > 0 &&
      this.bookingFormV4.pieces.every(
        (piece) =>
          piece.grossWeight > 0 &&
          piece.length > 0 &&
          piece.width > 0 &&
          piece.height > 0
      );
    return !!(
      this.districtDetail.code &&
      this.destinationCityDetail?.code &&
      this.bookingFormV4.commodity.id &&
      this.bookingFormV4.product.productType &&
      hasCompletePieces
    );
  }

  get footerChargeableWeightKg(): number {
    return this.bookingFormV4.estimationPrice.chargeableWeight;
  }

  resetEstimationPrice(): void {
    this.estimationRequestId += 1;
    this.bookingFormV4.estimationPrice = new EstimationPrice();
    this.estimationLoading = false;
    this.estimationIsError = false;
  }

  async getEstimationPrice(): Promise<void> {
    if (!this.isTariffContextReady) {
      this.resetEstimationPrice();
      return;
    }

    const requestId = ++this.estimationRequestId;

    try {
      this.estimationLoading = true;
      this.estimationIsError = false;
      if (this.productUpsellingLoading) {
        this.fetchPromisesAfterGetUpselling.push("getEstimationPriceDebounced");
        return;
      }
      const estimationPrice = await BookingV4Controller.getEstimationPrice(
        this.estimationPriceContextPayload
      );
      if (requestId !== this.estimationRequestId) return;
      this.bookingFormV4.estimationPrice = estimationPrice;
    } catch (error) {
      if (requestId !== this.estimationRequestId) return;
      this.estimationIsError = true;
    } finally {
      if (requestId === this.estimationRequestId) {
        this.estimationLoading = false;
      }
    }
  }

  getEstimationPriceDebounced = debounce(() => {
    this.getEstimationPrice();
  }, 500);

  onTariffRefresh(): void {
    this.getEstimationPrice();
  }

  getSupportingDocUrls(
    document: DocInternationalBookingV4,
    includeAdditionalDocuments: boolean
  ): string[] {
    const additionalUrls = includeAdditionalDocuments
      ? this.bookingFormV4.supportingDoc.additionalDocuments.map(
          (item) => item.url
        )
      : [];
    const urls: unknown[] = [
      document.imageBeforePackingUrl,
      document.imageAfterPackingUrl,
      ...additionalUrls
    ];
    return urls.map((url) => this.getSupportingDocUrl(url)).filter(Boolean);
  }

  getSupportingDocUrl(value: unknown): string {
    if (typeof value !== "string" || value.startsWith("blob:")) return "";
    return value;
  }

  closeReceiptFormatMenu() {
    this.showReceiptFormatMenu = false;
  }

  toggleReceiptFormatMenu() {
    this.showReceiptFormatMenu = !this.showReceiptFormatMenu;
  }

  onReceiptFormatClick(value: ReceiptFormatV4Value) {
    this.showReceiptFormatMenu = false;
    this.bookingFormV4.pageMeta.receiptFormat = value;
  }

  validationPrefix(prefix: string[]): boolean {
    const id = this.bookingFormV4.shipmentId;
    return prefix.some((e) => id.startsWith(e));
  }

  get isB1APAS() {
    return this.validationPrefix(["B1", "AP", "AS"]);
  }

  get isShipmentFavorite(): boolean {
    return this.validationPrefix(["AP", "AS"]);
  }

  get isCAPrefix() {
    const id = this.bookingFormV4.shipmentId;
    return isCustomerApps(id);
  }

  get isCaSpecificPrefix() {
    return this.validationPrefix(["AG", "AD", "AO", "AR"]);
  }

  get isCorporatePrefix() {
    return this.validationPrefix(["C1", "C2"]);
  }

  get isTokopediaPrefix() {
    return this.validationPrefix(["T1", "TKLP", "TKP", "TSLP"]);
  }

  get isB1B2() {
    return this.validationPrefix(["B1", "B2"]);
  }

  get isAPASPrefix() {
    return this.validationPrefix(["AP", "AS"]);
  }

  configRuleAdjustStt = new SttReferenceAdjustment({
    config: new SttAdjustment()
  });

  get configRule(): SttAdjustment {
    return this.configRuleAdjustStt.config;
  }

  get isShipmentMp(): boolean {
    const flags = FlagsPermissionBooking.permission_shipment_booking_mp.getValue();
    return Boolean(
      flags && new RegExp(flags).test(this.bookingFormV4.shipmentId)
    );
  }

  get isProductSameday(): boolean {
    return (
      BookingController.isSameDayProduct &&
      /sameday/i.test(this.bookingFormV4.product.productType)
    );
  }

  get configDisableC1() {
    return (
      !prefixDisableDimensionC1(
        String(AccountController.accountData.account_id)
      ) && this.validationPrefix(["C1", "C2"])
    );
  }

  get isVendorNinja(): boolean {
    return ShipmentBookingController.isVendorNinja;
  }

  get disabledPiece() {
    const { STT } = this.shipmentDetail;
    const {
      pieces,
      adjustmentWeightAttachments,
      shipmentId
    } = this.bookingFormV4;

    const adjustmentWeight =
      this.validationPrefix([
        "T1",
        "TKLP",
        "TKP",
        "C1",
        "C2",
        "AD",
        "ACA",
        "ACB",
        "AO",
        "AI",
        "ARA",
        "ARB",
        "AG",
        "B1",
        "B2"
      ]) && adjustmentWeightAttachments.filter(Boolean).length < 2;

    // disabled for piece list gross weight and volume weight
    const isPrefixDisableDimension = prefixDisableDimension(shipmentId);
    const disabledPieceDetail =
      isPrefixDisableDimension &&
      [
        STT?.sttId,
        this.isShipmentMp,
        this.configDisableC1,
        adjustmentWeight,
        this.isProductSameday
      ].some(Boolean);

    if (!disabledPieceDetail) {
      this.configRule.grossWeight = this.mapSttAdjustmentRule(false);
      this.configRule.dimension = this.mapSttAdjustmentRule(false);
    }

    if (!adjustmentWeight) {
      this.configRule.grossWeight = this.mapSttAdjustmentRule(true);
      this.configRule.dimension = this.mapSttAdjustmentRule(true);
    }

    // disabled for add pieces
    let disabledAddPiece = false;
    if (!this.isProductSameday) {
      const sumWeight = (key: keyof PieceBookingV4) =>
        pieces.reduce((total, p) => total + Number(p[key]), 0);

      const overMaxWeight = ["grossWeight", "volumeWeight"].some(
        (type: any) => sumWeight(type) > maxKg
      );
      const greatherMaxPiece = pieces.length > 15;

      disabledAddPiece = [
        this.isVendorNinja,
        overMaxWeight,
        !this.isShipmentMp,
        !this.configDisableC1,
        greatherMaxPiece
      ].some(Boolean);
    }

    return {
      grossWeight: disabledPieceDetail,
      dimension: disabledPieceDetail || isPrefixDisableDimension,
      addPiece: disabledAddPiece,
      adjustmentWeight
    };
  }

  initAdjustmentStt() {
    const { isDO } = this.shipmentDetail;
    const { protectionPacking, paymentMethod, receiver, product } = this.bookingFormV4;

    const isSameDayProduct = /sameday/i.test(product.productType);

    this.configRuleAdjustStt = new SttReferenceAdjustment({
      config: new SttAdjustment({
        senderName: this.mapSttAdjustmentRule(this.isB1APAS),
        senderPhone: this.mapSttAdjustmentRule(this.isB1APAS),
        senderAddress: this.mapSttAdjustmentRule(this.isB1APAS),
        recipientName: this.mapSttAdjustmentRule(isSameDayProduct ? !receiver.name : this.isB1APAS),
        recipientPhone: this.mapSttAdjustmentRule(isSameDayProduct ? !receiver.phone : this.isB1APAS),
        recipientAddress: this.mapSttAdjustmentRule(isSameDayProduct ? !receiver.address : this.isB1APAS),
        recipientDistrict: this.mapSttAdjustmentRule(isSameDayProduct ? !receiver.destinationCity : this.isB1APAS),
        recipientPostalCode: this.mapSttAdjustmentRule(
          this.isB1APAS || !receiver.postalCode
        ),
        productType: this.mapSttAdjustmentRule(this.isB1APAS),
        sttNoRefExternal: this.mapSttAdjustmentRule(this.isB1APAS || isDO),
        commodity: this.mapSttAdjustmentRule(true),
        goodsPrice: this.mapSttAdjustmentRule(
          this.isB1APAS ||
            (this.isCorporatePrefix ? !this.validateEstimationPrice(protectionPacking.itemPrice) : this.validateEstimationPrice(protectionPacking.itemPrice))
        ),
        codAmount: this.mapSttAdjustmentRule(
          this.isB1APAS || !paymentMethod.codAmount
        ),
        serviceType: this.mapSttAdjustmentRule(this.isB1APAS),
        insurance: this.mapSttAdjustmentRule(this.isB1APAS),
        grossWeight: this.mapSttAdjustmentRule(this.disabledPiece.grossWeight),
        dimension: this.mapSttAdjustmentRule(this.disabledPiece.dimension),
        adjustPiece: this.mapSttAdjustmentRule(this.disabledPiece.addPiece),
        adjustPieceAdd: this.mapSttAdjustmentRule(this.disabledPiece.addPiece),
        adjustPieceRemove: this.mapSttAdjustmentRule(
          this.disabledPiece.addPiece
        ),
        interCipl: this.mapSttAdjustmentRule(
          this.isB1APAS || this.isCorporatePrefix
        ),
        interEmail: this.mapSttAdjustmentRule(
          this.isB1APAS || this.isCorporatePrefix
        ),
        interIdentityNo: this.mapSttAdjustmentRule(
          this.isB1APAS || this.isCorporatePrefix
        ),
        interTaxNo: this.mapSttAdjustmentRule(
          this.isB1APAS || this.isCorporatePrefix
        ),
        interDutyTaxTerms: this.mapSttAdjustmentRule(
          this.isB1APAS || this.isCorporatePrefix
        ),
        interImageAfterPacking: this.mapSttAdjustmentRule(
          this.isB1APAS || this.isCorporatePrefix
        ),
        interImageBeforePacking: this.mapSttAdjustmentRule(
          this.isB1APAS || this.isCorporatePrefix
        ),
        interImageEmail: this.mapSttAdjustmentRule(
          this.isB1APAS || this.isCorporatePrefix
        ),
        interImageTaxNo: this.mapSttAdjustmentRule(
          this.isB1APAS || this.isCorporatePrefix
        ),
        manualSttNo: this.mapSttAdjustmentRule(this.isB1APAS || isDO),
        woodpacking: this.mapSttAdjustmentRule(this.isB1APAS)
      })
    });
  }

  mapSttAdjustmentRule(isEditable: boolean) {
    return new SttAdjustmentRule({
      rule: isEditable
        ? ConfigValidationForm.EDITABLE
        : ConfigValidationForm.NON_EDITABLE
    });
  }

  get supportingDocAdjustRules(): Partial<
    Record<SupportingDocFieldKey, SttAdjustmentRule>
  > {
    const c = this.configRule;
    const inter = {
      email: c.interEmail,
      idNumber: c.interIdentityNo,
      taxNumber: c.interTaxNo,
      imageId: c.interImageEmail,
      imageTax: c.interImageTaxNo,
      imageBeforePacking: c.interImageBeforePacking,
      imageAfterPacking: c.interImageAfterPacking,
      dutyTaxTerms: c.interDutyTaxTerms
    };
    const ftz = {
      email: c.ftzEmail,
      idNumber: c.ftzIdentityNo,
      taxNumber: c.ftzTaxNo,
      imageId: c.ftzImageEmail,
      imageTax: c.ftzImageTaxNo,
      imageBeforePacking: c.ftzImageBeforePacking,
      imageAfterPacking: c.ftzImageAfterPacking
    };

    return this.isFtzForm ? ftz : inter;
  }

  validateEstimationPrice(price: number | null): boolean {
    if (!this.hasAttemptedSubmit) {
      return this.computeItemPriceHasError(price);
    }

    this.validateErrorPrice();
    const validateAll = price ? !!this.errors.itemPrice : false;
    if (!validateAll) {
      this.currentIndex = 100;
    }
    return validateAll;
  }

  computeItemPriceHasError(price: number | null): boolean {
    if (!price || price <= 0) return true;

    if (
      this.bookingFormV4.paymentMethod.method === PaymentMethodV4.COD ||
      this.bookingFormV4.paymentMethod.method === PaymentMethodV4.DFOD
    ) {
      const ccoConfig =
        this.bookingFormV4.paymentMethod.method === PaymentMethodV4.DFOD
          ? this.ccoDfodActive
          : this.ccoCodActive;
      return price < ccoConfig.ccoMinPrice || price > ccoConfig.ccoMaxPrice;
    }

    return false;
  }

  openAdjustmentWeight = false;

  get removePieceTigger() {
    return this.bookingFormV4.pieces.length;
  }

  setErrorPiece() {
    const belowInit =
      this.bookingFormV4.pieces.length <
      this.shipmentDetail.shipmentGoodDetail.length;

    this.errors.pieces = belowInit
      ? this.$t("bookingV4.shipment.additionalWeight.belowPieces")
      : "";
  }

  get displayGoodsName(): boolean {
    return this.validationPrefix(["T1", "B1", "B2", "TKP", "TKLP"]);
  }
  get goodsName(): string {
    return this.shipmentDetail.shipmentGoodDetail
      .map((item) => item["shipment_goods_name"])
      .join(", ");
  }

  get isMandatoryUploadProofAdjust() {
    const weight = this.shipmentDetail.shipmentGoodDetail.map(
      (item) => item.shipment_goods_weight
    );
    const isDifferent = this.bookingFormV4.pieces.some(
      (value, index) => value.grossWeight !== weight[index]
    );
    const addedImage = this.bookingFormV4.adjustmentWeightAttachments.filter(
      (item) => item !== ""
    );
    return isDifferent && addedImage.length < 2 && !this.isB1APAS;
  }

  triggerAllFormErrors(): void {
    if (!this.isSenderSectionValid) {
      this.triggerSenderRequiredErrors();
    }
    if (!this.isReceiverSectionValid) {
      this.triggerReceiverRequiredErrors();
    }
    if (this.isReferenceRequired && !this.isReferenceSectionValid) {
      this.errors.referenceNumber = this.$t(
        "bookingV4.reference.error.required"
      ) as string;
    }
    this.triggerGoodsPackageErrors();

    // check is supporting doc required
    const {
      imageId,
      imageTax,
      imageBeforePacking,
      imageAfterPacking
    } = this.supportingDocFieldRules;

    // check is supporting doc empty
    const {
      imageIdUrl,
      imageTaxUrl,
      imageBeforePackingUrl,
      imageAfterPackingUrl
    } = this.isFtzForm
      ? this.bookingFormV4.supportingDoc.ftzForm
      : this.bookingFormV4.supportingDoc.docInternational;

    const isSupportingDocImageValid = [
      imageIdUrl || !imageId?.isRequired,
      imageTaxUrl || !imageTax?.isRequired,
      imageBeforePackingUrl || !imageBeforePacking?.isRequired,
      imageAfterPackingUrl || !imageAfterPacking?.isRequired
    ].every(Boolean);

    if (
      this.showSupportingDocSection &&
      !this.isSupportingDocSectionValid &&
      !isSupportingDocImageValid
    ) {
      this.errors.supportingDoc = this.$t(
        "bookingV4.supportingDoc.error.required"
      ) as string;
    }
    this.validateErrorPrice();
  }

  triggerSenderRequiredErrors(): void {
    const sender = this.bookingFormV4.sender;
    if (!sender.name) {
      this.errors.sender = this.$t(
        "bookingV4.sender.name.error.required"
      ) as string;
    }
    if (!sender.phone) {
      this.errors.phoneSender = this.$t(
        "bookingV4.sender.phone.error.required"
      ) as string;
    }
    if (!sender.address) {
      this.errors.addressSender = this.$t(
        "bookingV4.sender.address.error.required"
      ) as string;
    }
  }

  triggerReceiverRequiredErrors(): void {
    const receiver = this.bookingFormV4.receiver;
    const isInternational = this.activeTab === BookingTabV4.INTERNATIONAL;

    if (!receiver.name) {
      this.errors.receiver = this.$t(
        "bookingV4.recipient.name.error.required"
      ) as string;
    }
    if (!receiver.phone) {
      this.errors.phoneReceiver = this.$t(
        "bookingV4.recipient.phone.error.required"
      ) as string;
    }
    if (!receiver.address) {
      this.errors.addressReceiver = this.$t(
        "bookingV4.recipient.address.error.required"
      ) as string;
    }
    if (isInternational && !receiver.destinationCountryCode) {
      this.errors.destinationCountry = this.$t(
        "bookingV4.recipient.country.error.required"
      ) as string;
    }
    if (!receiver.destinationCity) {
      this.errors.destinationCity = isInternational
        ? (this.$t(
            "bookingV4.recipient.city.error.requiredInternational"
          ) as string)
        : (this.$t("bookingV4.recipient.city.error.required") as string);
    }
    // postalCode sengaja tidak divalidasi di sini karena
    // ReceiverSectionV4 menerima :isPostalCodeRequired="false"
  }

  triggerGoodsPackageErrors(): void {
    const commodity = this.bookingFormV4.commodity;
    const isCommodityEmpty = !commodity || !commodity.code || !commodity.name;

    if (isCommodityEmpty) {
      this.errors.commodity = this.$t(
        "bookingV4.goods.commodity.errorRequired"
      ) as string;
    }

    this.bookingFormV4.pieces.forEach((piece) => {
      if (!piece.grossWeight || piece.grossWeight <= 0) {
        piece.error.errorMandatoryGrossWeight = true;
      }
      if (!piece.length || !piece.width || !piece.height) {
        piece.error.errorMandatoryVolumeWeight = true;
      }
    });

    this.$nextTick(() => {
      const goodsPackage = this.$refs.goodsPackageRef;
      if (
        goodsPackage &&
        typeof goodsPackage.touchAllItemDetailsRows === "function"
      ) {
        goodsPackage.touchAllItemDetailsRows();
      }
    });
  }

  get preventDecreasedWeight() {
    return this.validationPrefix(["AG", "AD", "ARA", "ARB"]);
  }

  originalChWeight = 0;
  get isMaxChWeightTokopedia() {
    if (!this.originalChWeight) return false;

    return (
      this.isTokopediaPrefix &&
      gapValidationCHWeightTokped(
        this.originalChWeight,
        this.chargeableWeightBreakdown.finalCwKg
      )
    );
  }

  get eligibleEditSize() {
    return this.validationPrefix(["AP", "AS"]);
  }

  // client cod international
  get isCrossCountryRoute(): boolean {
    const destination = (
      this.destinationCityDetail?.countryCode || ""
    ).toUpperCase();
    const origin = (this.originCountry || "").toUpperCase();
    return !!(origin && destination && origin !== destination);
  }

  get isCodOrDfodPaymentMethod(): boolean {
    return (
      this.bookingFormV4.paymentMethod.method === PaymentMethodV4.COD ||
      this.bookingFormV4.paymentMethod.method === PaymentMethodV4.DFOD
    );
  }

  get isCrossCountryCod(): boolean {
    return (
      this.isCorporatePrefix &&
      this.isCrossCountryRoute &&
      this.isCodOrDfodPaymentMethod
    );
  }

  get codConfigByDestination() {
    return new CodInternationalCountry(
      this.configCodInternationalClient.countries.find(
        (c) =>
          c.countryCode === this.bookingFormV4.receiver.destinationCountryCode
      )
    );
  }

  // country data
  countryList = [] as CountryData[];
  async getCountryList() {
    const res = await LocationController.getCountryList({
      search: "",
      status: "active",
      page: 1,
      limit: 250
    });

    if (!res?.countryData) return;

    this.countryList = res.countryData.map((item) => ({
      ...item,
      label: `${item.name} (${item.code})`
    }));
  }
}

export default ModalShipmentV4;
